/* PLATINUM PET FOOD FINDER — CAT v2.6 (2026-04-24) */
// ================================================================
// Cat quiz: MeatCrisp produkti, FreshMeatDryer tehnologija
// 9 screenov, 6 vpra\u0161anj, max 2 upsella
// v2.6: OralClean+Care Classic \u2014 nova cena 35.86\u20ac (prej 29.98\u20ac),
//       osve\u017een desc (master doc v1.1 align: "Zobni kamen stran brez
//       narkoze in stresa. Vidna razlika v nekaj tednih, sve\u017e dah \u017ee v dneh.").
//       Name update: "OralClean+Care Gel" \u2192 "OralClean+Care Classic".
//       Handle + trigger ostajata enaka (senior). n8n email blurb osve\u017een.
// v2.5: Fix email flow \u2014 ko user preskoci prvi email screen in vpise
//       email \u0161ele na result strani, submitResEmail() zdaj direktno
//       fire-a Cat Email Flow webhook (cat-pff-email-flow) z emailRow
//       payloadom. Prej: samo nastavil S.email lokalno, brez fetch klica,
//       zato n8n Email Flow ni nikoli dobil emaila.
//       OPOMBA: NE kli\u010demo submitQuizData() \u2014 to bi re-sprozilo
//       Cat Quiz Submit workflow in pomenilo 2. Supabase row + 2. QA
//       Gmail alert. Direkten klic v Email Flow je cleaner (1 Quiz Submit
//       ob quiz koncu, 1 direkten Email Flow klic ob email vnosu).
// v2.4: Upsell cleanup \u2014 odstranjena Merilna Posodica (ni prava cross-sell,
//       je brezpla\u010dno darilo). pickUpsells() dobil (a) senior prioriteto
//       (OralClean najprej \u010de 8+ let), (b) vedno padding do 2 preko
//       default triggerjev. Dodan 'default' trigger na LickiMat (2. fallback
//       poleg Snack Roll). n8n email flow bhyOZHMQO4y57Gqy: odstranjen
//       merilna iz UPSELL_BLURBS + UPSELL_HANDLES.
// v2.3: Summary tag \u2014 body condition label (BC1/BC4/BC5) namesto generi\u010dne
//       "prekomerna te\u017ea". renderResHeader: BC1="presuha/presuh",
//       BC4="malce prete\u017eka/prete\u017eek", BC5="prete\u017eka/prete\u017eek",
//       BC3=brez taga (idealno = nevtralno). Iste oznake kot BC kartice v Q3.
//       Health concern 'weight' lo\u010den: "nagnjenost k debelosti" (ne duplikat).
// v2.2: Fix "Že od X €/dan" double-rounding. calcBestCpd zdaj uporablja
//       Shopify TRUNC-on-discount metodo (enako kot renderQtyTable),
//       rabi gpd parameter. Prej: 0.73 \u00d7 0.88 = 0.64 (pre-zaokro\u017een
//       cpd), zdaj: TRUNC total / (g \u00d7 qty) \u00d7 gpd = 0.65 (ujema qty 6\u00d7 3kg).
// v2.1: Tavrin copy \u2014 dodani stavki v vseh 5 WhyIntro variantah
//       (kitten/sterilised F/M/fish/adult chicken) + senior opomba.
//       Vsebuje label-verified 1.500 mg/kg + customer benefit story
//       (srce, vid, \u017eiv\u010dni sistem). Regulatorno safe ("pomaga ohranjati",
//       ne "zdravi"). Trust bar + 6 razlogov ostaneta nespremenjena.
// v2.0: Fix qty discount pricing \u2014 ujema se s Shopify per-line-item rounding.
//       PREJ: round(base \u00d7 qty \u00d7 (1-d)) na TOTALU \u2192 cene 1-6 centov pod Shopify.
//       ZDAJ: TRUNC(base \u00d7 d, 2) = popust per unit \u2192 \u00d7 qty \u2192 odvzame od (base\u00d7qty).
//       Shopify metoda: rounding na line item (ne na totalu), TRUNC (ne round).
//       Vseh 5 Qty ujema Shopify (npr. 1.5kg 6\u00d7: bilo 103,38 \u20ac \u2192 zdaj 103,44 \u20ac).
// v1.9: Fix weight input \u2014 ko je polje imelo "10" in je uporabnik
//       tipkal "2,5", se je zaradi `inp.value='10'` clamp-a med tipkanjem
//       polje snap-alo nazaj na "10" (videti kot da tipkovnica ne dela).
//       Popravek: (1) odstranil forcibly inp.value='10' v onWeightInput
//       (clamp naredi blur handler), (2) dodan focus listener z select(),
//       da tipkanje ZAMENJA obstoje\u010do vrednost namesto da dodaja.
// v1.8: Dodana alt_cost_cpd v submitQuizData (manjkala, zato Klaviyo
//       kazal "None" za alt cene). Weight input: type="text" inputmode="decimal"
//       s custom +/- gumbi (stepWeight), vejica->pika v onWeightInput().
//       Copy: "Priblizna teza je dovolj." (krajse)
// v1.6: Review round 2 \u2014 revert Helena K. "briketki" (pomanj\u0161evalnica),
//       regulatorno omiljenje skin transition ("Vidno manj rde\u010dice"
//       \u2192 "Manj praskanja, rde\u010dica se postopoma umirja"),
//       senior opomba gender-aware (starej\u0161i ma\u010dek / starej\u0161a ma\u010dka)
// v1.5: Copy refinements \u2014 popravki quotes (Tina S., Helena K.),
//       gramatika (prilagojeno razmerje), tehnicizmi \u2192 customer language
//       (mikrohranila+vitamini, ojačevalci okusa, \u010dvrsto blato,
//       mo\u010dni zobki), "lovni instinkt" \u2192 vonj/tekstura prepri\u010data
// v1.4: Slike sync iz Supabase featured_image (vse 71 produktov dinami\u010dno)
// v1.3: Pravilne slike za upselle (iz Shopify products.json), to\u010den meso % per produkt
//       (Kitten Fish 86%, ostali Chicken 83% / Fish 82%)
// v1.2: RER clamp fix (roundTo2_5), bla\u017eji BC faktorji za sterilizirane,
//       hard floor (min iz PLATINUM tabele), BCS1 sterilised \u2192 Adult,
//       BCS5 adult indoor/aktiv \u2192 Sterilised alt z opozorilom
// v1.1: Price sync iz Supabase, OralClean handle fix, Best CPD logika,
//       UTM/duration payload, health "prebava" rename, 7-dnevni prehod,
//       8 upsellov (pogojni triggerji), 117/117 testov
// ================================================================

// ===== STATE =====
var S = {
  step: 0,
  name: '',
  gender: null,           // 'male'|'female'
  ageMonths: null,
  sterilised: null,       // true|false
  lifeStage: null,        // 'kitten'|'adult'|'sterilised'
  weightKg: null,
  bodyCondition: null,    // 1,3,4,5
  eatingHabits: null,     // 'good'|'sometimes'|'veryPicky'
  lifestyle: null,        // 'indoor'|'indoor-active'|'outdoor'
  allergens: [],
  healthConditions: [],   // ['skin','prebava','weight']
  email: null,
  emailOptin: true,
  _startTime: null
};

// ===== IMAGES =====
var IMG_BASE = 'https://cdn.shopify.com/s/files/1/0303/4310/2509/files/';
var CDN = 'https://cdn.shopify.com/s/files/1/0303/4310/2509';
var CAT_IMAGES = {
  welcome:    IMG_BASE + 'kviz-cat-welcome1.png',
  loading:    IMG_BASE + 'kviz-cat-loading1.png',
  kitten:     IMG_BASE + 'kviz-cat-kitten1.png',
  adult:      IMG_BASE + 'kviz-cat-welcome1.png',
  sterilised: IMG_BASE + 'kviz-cat-sterilised1.png',
  bc1:        IMG_BASE + 'kviz-cat-bc1.png',
  bc3:        IMG_BASE + 'kviz-cat-bc3.png',
  bc4:        IMG_BASE + 'kviz-cat-bc4.png',
  bc5:        IMG_BASE + 'kviz-cat-bc5.png',
  good:       IMG_BASE + 'kviz-cat-good1.png',
  sometimes:  IMG_BASE + 'kviz-cat-sometimes1.png',
  picky:      IMG_BASE + 'kviz-cat-picky1.png',
  indoor:     IMG_BASE + 'kviz-cat-indoor1.png',
  indoorActive: IMG_BASE + 'kviz-cat-indoor-active1.png',
  outdoor:    IMG_BASE + 'kviz-cat-outdoor1.png'
};

// ===== SCREENS =====
var SCREENS = ['scr-welcome','scr-q2','scr-q3','scr-q4','scr-q5','scr-q6','scr-email','scr-loading','scr-results'];

// ===== SLOVENIAN HELPERS =====
function poss(name) {
  if (!name) return '';
  var n = name.trim();
  var last = n.slice(-1).toLowerCase();
  if (last === 'a') return n.slice(0, -1) + 'in';
  if ('eiou'.includes(last)) return n + 'n';
  return n + 'ov';
}

function acc(name) {
  if (!name) return '';
  var n = name.trim();
  var last = n.slice(-1).toLowerCase();
  if (last === 'a') return n.slice(0, -1) + 'o';
  if ('eiou'.includes(last)) return n;
  return n + 'a';
}

function genderText(maleText, femaleText) {
  return S.gender === 'female' ? femaleText : maleText;
}

// ===== PRODUCTS — 6 MeatCrisp =====
var PRODUCTS = [
  { id:'adult-chicken', name:'MeatCrisp Adult Chicken', short:'Pi\u0161\u010danec', flavor:'chicken', allergens:['Koruza','Krompir','Ri\u017e','Pi\u0161\u010danec'], stage:'adult', kcal:386, handle:'meatcrisp-adult-chicken', shopifyId:'gid://shopify/Product/7785604874467', img:CDN+'/products/cat-adult-chicken-1.5kg.jpg', variants:[{sku:'1200',t:'400 g',p:6.55,g:400},{sku:'1210',t:'1.5 kg',p:19.58,g:1500},{sku:'1220',t:'3 kg',p:32.61,g:3000}] },
  { id:'adult-fish', name:'MeatCrisp Adult Fish', short:'Riba', flavor:'fish', allergens:['Koruza','Riba'], stage:'adult', kcal:378, handle:'meatcrisp-adult-fish', shopifyId:'gid://shopify/Product/8720670916936', img:CDN+'/files/cat-adult-fish-1.5kg.jpg', variants:[{sku:'1300',t:'400 g',p:6.96,g:400},{sku:'1310',t:'1.5 kg',p:21.33,g:1500},{sku:'1320',t:'3 kg',p:35.57,g:3000}] },
  { id:'sterilised-chicken', name:'MeatCrisp Sterilised Chicken', short:'Pi\u0161\u010danec', flavor:'chicken', allergens:['Koruza','Krompir','Ri\u017e','Pi\u0161\u010danec'], stage:'sterilised', kcal:356, handle:'meatcrisp-sterilised-chicken', shopifyId:'gid://shopify/Product/7785820815587', img:CDN+'/products/cat-sterilised-chicken-1.5kg.jpg', variants:[{sku:'1230',t:'400 g',p:6.55,g:400},{sku:'1240',t:'1.5 kg',p:19.58,g:1500},{sku:'1250',t:'3 kg',p:32.61,g:3000}] },
  { id:'sterilised-fish', name:'MeatCrisp Sterilised Fish', short:'Riba', flavor:'fish', allergens:['Koruza','Riba'], stage:'sterilised', kcal:354, handle:'meatcrisp-sterilised-fish', shopifyId:'gid://shopify/Product/8720769253704', img:CDN+'/files/cat-sterilised-fish-1.5kg.jpg', variants:[{sku:'1330',t:'400 g',p:6.96,g:400},{sku:'1340',t:'1.5 kg',p:21.33,g:1500},{sku:'1350',t:'3 kg',p:35.57,g:3000}] },
  { id:'kitten-chicken', name:'MeatCrisp Kitten Chicken', short:'Pi\u0161\u010danec', flavor:'chicken', allergens:['Koruza','Ri\u017e','Pi\u0161\u010danec'], stage:'kitten', kcal:396, handle:'meatcrisp-kitten-chicken', shopifyId:'gid://shopify/Product/7785942188259', img:CDN+'/products/cat-kitten-chicken-1.5kg.jpg', variants:[{sku:'1260',t:'400 g',p:7.10,g:400},{sku:'1270',t:'1.5 kg',p:21.33,g:1500},{sku:'1280',t:'3 kg',p:35.57,g:3000}] },
  { id:'kitten-fish', name:'MeatCrisp Kitten Fish', short:'Riba', flavor:'fish', allergens:['Koruza','Krompir','Riba'], stage:'kitten', kcal:388, handle:'meatcrisp-kitten-fish', shopifyId:'gid://shopify/Product/8720772989256', img:CDN+'/files/cat-kitten-fish-1.5kg.jpg', variants:[{sku:'1360',t:'400 g',p:7.64,g:400},{sku:'1370',t:'1.5 kg',p:23.41,g:1500},{sku:'1380',t:'3 kg',p:38.85,g:3000}] }
];

// ===== QUANTITY DISCOUNTS — MA\u010cKE (razli\u010dno od psov!) =====
var CAT_QTY = [{q:1,d:0},{q:2,d:0.04},{q:3,d:0.07},{q:4,d:0.10},{q:6,d:0.12}];

// ===== UPSELLS — max 2, pogojni prikaz =====
// Trigger logika v pickUpsells(): skin, prebava, weight, picky, kitten, senior, default
var UPSELLS = [
  { id:'skincare',      name:'SkinCare Supplement',   handle:'skincare',      price:18.98, trigger:['skin'],    desc:'Omega-3 dopolnilo za sijo\u010do dlako in zdravo ko\u017eo.',                         allergens:[], img:CDN+'/files/care-dog-cat-skincare.jpg' },
  { id:'skin-clean',    name:'Skin Clean+Care',       handle:'platinum-skin-clean-care-nega-koze-za-pse-in-macke', price:11.98, trigger:['skin'], desc:'Zunanji tonik za umirjanje ko\u017ee \u2014 naravna nega brez kemije.',   allergens:[], img:CDN+'/files/nega-koze-skin.jpg' },
  { id:'lickimat',      name:'LickiMat SLOMO Cat',    handle:'podloga-lickimat-r-slomo-cat',    price:14.35, trigger:['prebava','weight','default'],  desc:'Podloga za po\u010dasno hranjenje \u2014 manj po\u017eiranja, bolj\u0161a prebava.',  allergens:[], img:CDN+'/files/lickimat_slomo-cat_1.jpg' },
  { id:'snack-roll',    name:'Activity Snack Roll',   handle:'activity-igraca-za-macke',         price:5.98,  trigger:['picky','kitten','weight','default'], desc:'Interaktivna igra\u010dka \u2014 napolni z MeatCrisp briketi. Spodbuja lovski instinkt.', allergens:[], img:CDN+'/files/igraca-macke-2025-1_dc3cae20-015c-4cc4-9338-78d1ba2779c2.jpg' },
  { id:'oralclean',     name:'OralClean+Care Classic', handle:'oralclean-care-classic-gel',      price:35.86, trigger:['senior'],   desc:'Zobni kamen stran brez narkoze in stresa. Vidna razlika v nekaj tednih, sve\u017e dah pa \u017ee v dneh.', allergens:[], img:CDN+'/files/OCC_Classic_Gel_EN.jpg' },
  { id:'ear-clean',     name:'Ear Clean+Care',        handle:'platinum-ear-clean-care-nega-uses-za-pse-in-macke', price:16.48, trigger:['senior'], desc:'Ne\u017ena nega u\u0161es \u2014 \u010disti in prepre\u010duje vnetja.',    allergens:[], img:CDN+'/files/nega-koze-ear-liquid.jpg' },
  { id:'eye-clean',     name:'Eye Clean+Care',        handle:'platinum-eye-clean-care-nega-oci-za-pse-in-macke', price:16.98, trigger:['senior'], desc:'Naravna nega o\u010di \u2014 odstrani made\u017ee in umirja solzenje.',   allergens:[], img:CDN+'/files/nega-koze-eye-liquid.jpg' }
];

// ===== QUIZ DATA FETCH (Supabase price + kcal sync) =====
var QUIZ_DATA = {
  dataSource: 'fallback',
  loaded: false
};

var SUPABASE_URL = 'https://nvwzltbykmfjkhdmkjlg.supabase.co';
var SUPABASE_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im52d3psdGJ5a21mamtoZG1ramxnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM2NDQxODQsImV4cCI6MjA3OTIyMDE4NH0.CLcXHCrT0VkCQPiDpHmCV58DG79SNDSePq7SlzItXfU';

function fetchQuizData() {
  var controller = new AbortController();
  var timeout = setTimeout(function() { controller.abort(); }, 2500);

  var headers = {
    'apikey': SUPABASE_ANON,
    'Authorization': 'Bearer ' + SUPABASE_ANON
  };

  // Fetch cat products + care products (pet_type=cat OR pet_type=both)
  fetch(SUPABASE_URL + '/rest/v1/social_products?select=handle,kcal_per_100g,variants,featured_image&available=eq.true&or=(pet_type.eq.cat,pet_type.eq.both)', {
    headers: headers, signal: controller.signal
  }).then(function(res) {
    clearTimeout(timeout);
    if (!res.ok) throw new Error('HTTP ' + res.status);
    return res.json();
  }).then(function(spData) {
    var priceUpdates = 0;
    var imageUpdates = 0;

    spData.forEach(function(row) {
      var variants = row.variants;
      if (typeof variants === 'string') { try { variants = JSON.parse(variants); } catch(e) { variants = null; } }

      // --- MeatCrisp products: kcal + price + image sync ---
      var p = PRODUCTS.find(function(p) { return p.handle === row.handle; });
      if (p) {
        if (row.kcal_per_100g) p.kcal = Math.round(parseFloat(row.kcal_per_100g));
        if (row.featured_image) { p.img = row.featured_image; imageUpdates++; }
        if (variants && variants.length) {
          variants.forEach(function(sv) {
            var v = p.variants.find(function(v) { return v.sku === sv.sku; });
            if (v && sv.price != null) { v.p = parseFloat(sv.price); priceUpdates++; }
          });
        }
      }

      // --- Upsells: price + image sync ---
      var u = UPSELLS.find(function(u) { return u.handle === row.handle; });
      if (u) {
        if (row.featured_image) { u.img = row.featured_image; imageUpdates++; }
        if (variants && variants[0] && variants[0].price != null) {
          u.price = parseFloat(variants[0].price);
          priceUpdates++;
        }
      }
    });
    console.log('[CAT PFF] Image sync: ' + imageUpdates + ' images updated from Supabase');

    QUIZ_DATA.dataSource = 'supabase';
    QUIZ_DATA.loaded = true;
    console.log('[CAT PFF] Price sync: ' + priceUpdates + ' prices updated from Supabase');

  }).catch(function(err) {
    clearTimeout(timeout);
    QUIZ_DATA.loaded = true;
    console.warn('[CAT PFF] fetchQuizData fallback:', err.message);
  });
}

// Fetch on load
fetchQuizData();

// ===== FEEDING TABLES (from cat-feeding-tables.json) =====
var FEED = {
  chicken: {
    kitten: {
      '<=2':  [{w:0.5,g:40},{w:1,g:63},{w:1.5,g:83},{w:2,g:100}],
      '3-4':  [{w:1,g:50},{w:1.5,g:66},{w:2,g:80},{w:2.5,g:93},{w:3,g:105}],
      '5-9':  [{w:1.5,g:58},{w:2,g:70},{w:2.5,g:81},{w:3,g:92},{w:3.5,g:102},{w:4,g:112},{w:4.5,g:121},{w:5,g:130}],
      '10-12':[{w:2.5,g:70},{w:3,g:79},{w:3.5,g:88},{w:4,g:96},{w:4.5,g:104},{w:5,g:111},{w:5.5,g:119},{w:6,g:126}]
    },
    adult:      [{w:2,g:41},{w:3,g:54},{w:4,g:65},{w:5,g:76},{w:6,g:86},{w:7,g:95},{w:8,g:104}],
    sterilised: [{w:2,gMin:23,gMax:34},{w:3,gMin:30,gMax:44},{w:4,gMin:37,gMax:53},{w:5,gMin:42,gMax:62},{w:6,gMin:48,gMax:70},{w:7,gMin:53,gMax:78},{w:8,gMin:58,gMax:85}]
  },
  fish: {
    kitten: {
      '<=2':  [{w:0.5,g:41},{w:1,g:64},{w:1.5,g:85},{w:2,g:102}],
      '3-4':  [{w:1,g:51},{w:1.5,g:67},{w:2,g:82},{w:2.5,g:95},{w:3,g:107}],
      '5-9':  [{w:1.5,g:59},{w:2,g:71},{w:2.5,g:83},{w:3,g:94},{w:3.5,g:104},{w:4,g:114},{w:4.5,g:123},{w:5,g:133}],
      '10-12':[{w:2.5,g:71},{w:3,g:81},{w:3.5,g:90},{w:4,g:98},{w:4.5,g:106},{w:5,g:113},{w:5.5,g:121},{w:6,g:129}]
    },
    adult:      [{w:2,g:42},{w:3,g:55},{w:4,g:66},{w:5,g:78},{w:6,g:88},{w:7,g:97},{w:8,g:106}],
    sterilised: [{w:2,gMin:23,gMax:34},{w:3,gMin:30,gMax:44},{w:4,gMin:37,gMax:53},{w:5,gMin:42,gMax:62},{w:6,gMin:48,gMax:70},{w:7,gMin:53,gMax:78},{w:8,gMin:58,gMax:85}]
  }
};

// ===== QUOTES / SOCIAL PROOF =====
// Prave recenzije iz Judge.me (Supabase social_kb_entries, source_type=judgeme)
// Izbor po cat-pff-vse-v-enem-povzetek.md priporočilu
var QUOTES = {
  'adult-chicken': [
    {text:'Kon\u010dno smo na\u0161li hrano, ki odgovarja na\u0161i scrkljani in neje\u0161\u010di Dori. \u0160koda, da ne morem poslati videa, da bi sli\u0161ali kako hrusta hrano.', author:'Marija L.'},
    {text:'Na\u0161a Shelli je zelo zbir\u010dna muca. Predno sem ga uspela pretresti v njeno skodelico, si je sama odprla vre\u010dko.', author:'Mojca V.'},
    {text:'Na\u0161 Ar\u010di ni ve\u010d maral Acana briketov. Probali ve\u010d vzorcev \u2014 potem pa chicken MeatCrisp in jih z u\u017eitkom je.', author:'Ana V.'},
    {text:'Na\u0161 ma\u010dek je izbir\u010den, katero koli smo kupili ni hotel jest dokler nismo probal Platinum. Zdej pa poje tudi same brikete brez mokre hrane.', author:'Tja\u0161a \u0160.'},
    {text:'Jussi naravnost obo\u017euje MeatCrisp brikete. Zdaj je skodelica polna, zdaj je prazna!', author:'Anonimno'}
  ],
  'adult-fish': [
    {text:'Odli\u010dni briketi! Na\u0161emu izbir\u010dnemu in slabo je\u0161\u010demu Mucu izredno taknejo.', author:'Anonimno'},
    {text:'Kvalitetna hrana. Muce imajo alergije, a to hrano prena\u0161ajo dobro.', author:'Anonimno'},
    {text:'Na\u0161a muca jih obo\u017euje in resni\u010dno se vidi, kako u\u017eiva v hrustanju. Skledica je vedno povsem prazna.', author:'Petra S.'},
    {text:'Top hrana. Na\u0161 britanc obo\u017euje va\u0161o hrano \u2014 prvi\u010d sem kupila z okusom ribe, ampak je ravno nasprotno.', author:'Mateja K.'},
    {text:'Moj Sr\u010dko priporo\u010da 100% \u2014 zelo sva zadovoljna oba. On, ko mu skledico napolnim, in jaz, ko jo vidim prazno.', author:'Ines \u0106.'}
  ],
  'sterilised-chicken': [
    {text:'Na\u0161 Kobi je zelo dobro sprejel brikete za sterilizirane ma\u010dke. Ne pridobiva na te\u017ei in ima dobro prebavo.', author:'Klavdija G.'},
    {text:'Na\u0161a ma\u010dka je takoj za\u010dela jesti va\u0161o hrano. Ni bilo treba ni\u010d me\u0161ati s prej\u0161njo hrano.', author:'Tatjana R.'},
    {text:'Na\u0161a mucka tako veselo hrusta te slastne brikete, kot \u0161e nikoli prej. Vsak dan poje celo dnevno porcijo.', author:'\u0160pela M.'},
    {text:'Odli\u010dno! Na\u0161 izbir\u010den muc jih zelo zelo zelo rad j\u00e9.', author:'Tja\u0161a K.'},
    {text:'Na\u0161a 17 let stara muca obo\u017euje to hrustljavo hrano. O\u010ditno je tako okusna, da bi kar jedla in jedla.', author:'Ur\u0161ka G.'}
  ],
  'sterilised-fish': [
    {text:'Po 19 letih kon\u010dno hrane, ki ne povzro\u010da bruhanja.', author:'Simona K.'},
    {text:'Luna je zelo zelo izbir\u010dna ma\u010dka, suhe hrane skorajda no\u010de niti poizkusit. Sedaj je prvi\u010d, da jo pohrusta vsak dan.', author:'Drago O.'},
    {text:'Odli\u010dna hrana. Izmed na\u0161ih muc po ve\u010d briketih bruha ali dobi alergijo. Po teh je super.', author:'Tina S.'},
    {text:'Moja muca Pika je zbolela, zavra\u010dala hrano... Iskala sem kvalitetne brikete \u2014 ko je pojedla prvo porcijo, sem skakala od veselja.', author:'Tadeja K.'}
  ],
  'kitten-chicken': [
    {text:'Iskala sem nekaj naravnega ker imamo zelo izbir\u010dno muco \u2014 po antibiotikih ni jedla ni\u010d. Na MeatCrisp pa je za\u010dela.', author:'Mojca S.'},
    {text:'Moja ma\u010dka do sedaj zavra\u010dala vse brikete. Te pa ima zelo rada.', author:'Eva L.'},
    {text:'Moji dve cartki sta nad njo zelo navdu\u0161eni, odkar jesta va\u0161e brikete drugih se povohata ne.', author:'Tina H.'},
    {text:'Moj Muri je zelo izbir\u010den, ampak tile briketki mu res gredo v slast, tako da sva oba zadovoljna.', author:'Helena K.'},
    {text:'Na\u0161 Sky obo\u017euje to hrano, in zagotovo bo vedno na njegovem jedilniku.', author:'Mateja K.'}
  ],
  'kitten-fish': [
    {text:'Svoji muciki \u017eelim nuditi le najbolj\u0161e. Je izbir\u010dna muca vendar to hrano z veseljem je.', author:'Ema \u0160.'},
    {text:'Uvajamo mucku ki ima gastro te\u017eave \u2014 do zdaj je bilo vse ok, upamo da tako ostane.', author:'Nina K.'},
    {text:'Lepo di\u0161i, na\u0161 ma\u010dek Gigi je zelo zadovoljen, dlaka lepa, mehka in sijo\u010da.', author:'Anonimno'},
    {text:'Na\u0161 Simba obo\u017euje MeatCrisp Kitten Fish. Postal je pravi jedec.', author:'Renata A.'},
    {text:'Enostavno so z njo obsedeni od malega do starega.', author:'Olga \u017d.'}
  ]
};

// ===== GA4 =====
function ga4(event, params) {
  params = params || {};
  params.species = 'cat';
  if (typeof gtag === 'function') gtag('event', event, params);
}

// ===== EUR FORMAT =====
function fmtEur(n) { return n.toFixed(2).replace('.', ','); }

// ===== PROGRESS BAR =====
function renderProgressBar(stepIdx) {
  var phases = [
    { label: 'MOJA MA\u010cKA', screens: [1, 2] },
    { label: 'ANALIZA', screens: [3, 4, 5] },
    { label: 'TVOJ PLAN', screens: [6] }
  ];
  var html = '';
  phases.forEach(function(p, i) {
    var isActive = p.screens.indexOf(stepIdx) !== -1;
    var isDone = stepIdx > Math.max.apply(null, p.screens);
    var dotCls = isDone ? 'done' : isActive ? 'active' : '';
    var lblCls = isDone ? 'done' : isActive ? 'active' : '';
    html += '<div class="pb-step"><span class="pb-label ' + lblCls + '">' + p.label + '</span><div class="pb-dot ' + dotCls + '"></div></div>';
    if (i < phases.length - 1) {
      var fillPct = 0;
      if (isDone) fillPct = 100;
      else if (isActive) {
        var pIdx = p.screens.indexOf(stepIdx);
        fillPct = ((pIdx + 1) / p.screens.length) * 100;
      }
      html += '<div class="pb-track"><div class="pb-track-fill" style="width:' + fillPct + '%"></div></div>';
    }
  });
  var pbMap = {1:'q2',2:'q3',3:'q4',4:'q5',5:'q6',6:'email'};
  var el = document.getElementById('pb-' + (pbMap[stepIdx] || 'q2'));
  if (el) el.innerHTML = html;
  // Step counter
  var topNav = el && el.closest('.top-nav');
  var counter = topNav && topNav.nextElementSibling;
  if (!counter || !counter.classList.contains('pb-counter')) {
    counter = document.createElement('div');
    counter.className = 'pb-counter';
    counter.style.cssText = 'text-align:center;font-size:11px;color:var(--g400);margin:-12px 0 12px';
    if (topNav) topNav.after(counter);
  }
  if (counter) {
    if (stepIdx >= 1 && stepIdx <= 5) counter.textContent = 'Vpra\u0161anje ' + stepIdx + ' od 6';
    else if (stepIdx === 6) counter.textContent = 'Skoraj kon\u010dano \u2014 samo \u0161e email za tvoj plan!';
    else counter.textContent = '';
  }
}

// ===== NAVIGATION =====
function showScr(idx) {
  SCREENS.forEach(function(id, i) {
    document.getElementById(id).classList.toggle('active', i === idx);
  });
  S.step = idx;
  if (idx === 1 && !S._startTime) S._startTime = Date.now();
  // Wider container for results
  document.getElementById('pet-food-finder-app').classList.toggle('results-active', idx === 8);
  // Hide sticky CTA when not on results
  if (idx !== 8) {
    var sEl = document.getElementById('sticky-cta');
    if (sEl) sEl.classList.remove('visible');
    if (_stickyObserver) { _stickyObserver.disconnect(); _stickyObserver = null; }
  }
  if (idx === 6) checkEmailReady();
  // Scroll to top
  var scEl = document.getElementById(SCREENS[idx]);
  void scEl.offsetHeight;
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  scEl.scrollIntoView({block: 'start'});
  setTimeout(function() { window.scrollTo(0, 0); scEl.scrollIntoView({block: 'start'}); }, 80);
}

function startQuiz() {
  S.name = document.getElementById('inp-name').value.trim();
  S.name = S.name.charAt(0).toUpperCase() + S.name.slice(1);
  ga4('quiz_cat_start', { quiz_name: 'cat-food-finder' });
  prepareScr(1);
  showScr(1);
}

function goBack() {
  if (S.step > 1) {
    var target = S.step - 1;
    restoreScr(target);
    showScr(target);
  } else {
    showScr(0);
  }
}

function goNext() {
  var next = S.step + 1;
  prepareScr(next);
  showScr(next);
}

// ===== PREPARE SCREEN =====
function prepareScr(idx) {
  var n = S.name || 'tvoja ma\u010dka';
  var na = acc(n);
  var np = poss(n);

  if (idx >= 1 && idx <= 6) renderProgressBar(idx);

  if (idx === 1) {
    // Q2: Starost + Spol + Sterilizacija
    document.getElementById('q2-title').textContent = 'Povej nam o ' + n + '!';
    var nameEl = document.getElementById('q2-name');
    if (nameEl) nameEl.textContent = n.toUpperCase();
    S.lifeStage = null;
    S.gender = null;
    S.sterilised = null;
    S.ageMonths = null;
    document.getElementById('sel-age').selectedIndex = 0;
    document.getElementById('sel-age').classList.add('placeholder');
    document.getElementById('q2-kitten-age-wrap').style.display = 'none';
    document.getElementById('sel-kitten-age').selectedIndex = 0;
    document.getElementById('sel-kitten-age').classList.add('placeholder');
    // Reset gender toggle
    document.querySelectorAll('#toggle-gender .toggle-btn').forEach(function(b) { b.classList.remove('sel'); });
    // Reset sterilised toggle
    document.querySelectorAll('#toggle-sterilised .toggle-btn').forEach(function(b) { b.classList.remove('sel'); });
    document.getElementById('q2-quote').textContent = '';
    document.getElementById('btn-q2').disabled = true;
  }
  if (idx === 2) {
    // Q3: Te\u017ea + Body Condition
    document.getElementById('q3-title').textContent = 'Koliko tehta ' + n + '?';
    document.getElementById('q3-sub').textContent = 'Prilagodimo koli\u010dino za zdravo kondicijo.';
    var f = S.gender === 'female';
    document.getElementById('lb-bc1').textContent = f ? 'Presuha' : 'Presuh';
    document.getElementById('lb-bc3').textContent = f ? 'Idealna te\u017ea' : 'Idealna te\u017ea';
    document.getElementById('lb-bc4').textContent = f ? 'Malce prete\u017eka' : 'Malce prete\u017eek';
    document.getElementById('lb-bc5').textContent = f ? 'Prete\u017eka' : 'Prete\u017eek';
    var infoEl = document.getElementById('q3-info');
    if (infoEl) infoEl.textContent = 'Prilagodimo dnevni obrok glede na dejansko postavo \u2014 tako ' + (f ? 'tvoja ma\u010dka dobi' : 'tvoj ma\u010dek dobi') + ' to\u010dno toliko, kot potrebuje.';
  }
  if (idx === 3) {
    // Q4: Je\u0161\u010dnost
    document.getElementById('q4-title').textContent = 'Kako je ' + n + ' z je\u0161\u010dnostjo?';
    var f4 = S.gender === 'female';
    document.getElementById('lb-good').textContent = f4 ? 'Dobra jedka' : 'Dober jedec';
    document.getElementById('lb-sometimes').textContent = f4 ? 'V\u010dasih izbir\u010dna' : 'V\u010dasih izbir\u010den';
    document.getElementById('lb-veryPicky').textContent = f4 ? 'Zelo izbir\u010dna' : 'Zelo izbir\u010den';
    S.eatingHabits = null;
    document.querySelectorAll('#scr-q4 .oc').forEach(function(c) { c.classList.remove('sel'); });
    document.getElementById('btn-q4').disabled = true;
  }
  if (idx === 4) {
    // Q5: \u017divljenjski slog
    var f5 = S.gender === 'female';
    document.getElementById('q5-title').textContent = 'Kak\u0161en je ' + np + ' \u017eivljenjski slog?';
    var subEl = document.getElementById('q5-sub');
    if (subEl) subEl.textContent = 'Prilagodimo priporo\u010dila glede na ' + (f5 ? 'njen' : 'njegov') + ' stil \u017eivljenja.';
    // Labele po spolu
    var lblIn = document.getElementById('lb-indoor');
    var lblAct = document.getElementById('lb-indoor-active');
    var lblOut = document.getElementById('lb-outdoor');
    if (lblIn) lblIn.textContent = f5 ? 'Doma\u010da ma\u010dka' : 'Doma\u010d ma\u010dek';
    if (lblAct) lblAct.textContent = f5 ? 'Aktivna doma' : 'Aktiven doma';
    if (lblOut) lblOut.textContent = 'Hodi ven';
    // Info tekst
    var infoEl = document.getElementById('q5-info');
    if (infoEl) infoEl.textContent = '\u017divljenjski slog vpliva na dnevni odmerek \u2014 prilagodimo ga za ' + n + '.';
    S.lifestyle = null;
    document.querySelectorAll('#scr-q5 .oc').forEach(function(c) { c.classList.remove('sel'); });
    document.getElementById('btn-q5').disabled = true;
  }
  if (idx === 5) {
    // Q6: Alergije + Zdravje
    document.getElementById('q6-title').textContent = 'Alergije in zdravje';
    document.getElementById('q6-name-al').textContent = n;
    document.getElementById('q6-name-health').textContent = n;
    S.allergens = ['brez'];
    S.healthConditions = [];
    document.getElementById('sel-al-toggle').value = 'nima';
    document.getElementById('sel-health-toggle').value = 'nima';
    document.getElementById('q6-al-options').style.display = 'none';
    document.getElementById('q6-health-options').style.display = 'none';
    document.querySelectorAll('#scr-q6 .pill').forEach(function(c) { c.classList.remove('sel'); });
  }
  if (idx === 6) {
    // Email capture
    document.getElementById('em-name-title').textContent = n + ' plan';
    document.getElementById('em-optin-label').textContent = '\u017delim prejemati nasvete za ' + n + ' in ekskluzivne ponudbe';
    document.getElementById('btn-email-submit').textContent = 'Po\u0161lji ' + n + ' plan na email \u2192';
  }
}

// ===== RESTORE SCREEN (goBack) =====
function restoreScr(idx) {
  var n = S.name || 'tvoja ma\u010dka';
  if (idx >= 1 && idx <= 6) renderProgressBar(idx);

  if (idx === 1) {
    document.getElementById('q2-title').textContent = 'Povej nam o ' + n + '!';
    // Restore age select
    if (S.ageMonths !== null) {
      if (S.ageMonths < 12) {
        document.getElementById('sel-age').value = 'kitten';
        document.getElementById('sel-age').classList.remove('placeholder');
        document.getElementById('q2-kitten-age-wrap').style.display = '';
        // Restore kitten sub-age
        var kitMap = {2:'0-2', 4:'3-4', 7:'5-9', 11:'10-12'};
        var kitVal = kitMap[S.ageMonths];
        if (kitVal) {
          document.getElementById('sel-kitten-age').value = kitVal;
          document.getElementById('sel-kitten-age').classList.remove('placeholder');
        }
      } else if (S.ageMonths >= 120) {
        document.getElementById('sel-age').value = 'senior';
        document.getElementById('sel-age').classList.remove('placeholder');
      } else {
        document.getElementById('sel-age').value = 'adult';
        document.getElementById('sel-age').classList.remove('placeholder');
      }
      document.getElementById('q2-quote').textContent = getAgeQuote(n);
    }
    // Restore gender toggle
    if (S.gender) {
      document.querySelectorAll('#toggle-gender .toggle-btn').forEach(function(b) {
        b.classList.toggle('sel', b.dataset.val === S.gender);
      });
    }
    // Restore sterilised toggle
    if (S.sterilised !== null) {
      var sterVal = S.sterilised ? 'yes' : 'no';
      document.querySelectorAll('#toggle-sterilised .toggle-btn').forEach(function(b) {
        b.classList.toggle('sel', b.dataset.val === sterVal);
      });
    }
    document.getElementById('btn-q2').disabled = !(S.ageMonths && S.gender && S.sterilised !== null);
  }
  if (idx === 2) {
    prepareScr(2);
    if (S.weightKg) {
      document.getElementById('inp-weight').value = S.weightKg;
      var bcWrap = document.getElementById('bc-wrap');
      if (bcWrap) bcWrap.style.display = '';
    }
    if (S.bodyCondition) {
      document.querySelectorAll('#scr-q3 .oc').forEach(function(c) {
        c.classList.toggle('sel', String(c.dataset.bc) === String(S.bodyCondition));
      });
    }
    document.getElementById('btn-q3').disabled = !(S.weightKg && S.bodyCondition);
  }
  if (idx === 3) {
    prepareScr(3);
    if (S.eatingHabits) {
      document.querySelectorAll('#scr-q4 .oc').forEach(function(c) {
        c.classList.toggle('sel', c.dataset.val === S.eatingHabits);
      });
      document.getElementById('btn-q4').disabled = false;
    }
  }
  if (idx === 4) {
    prepareScr(4);
    if (S.lifestyle) {
      document.querySelectorAll('#scr-q5 .oc').forEach(function(c) {
        c.classList.toggle('sel', c.dataset.val === S.lifestyle);
      });
      document.getElementById('btn-q5').disabled = false;
    }
  }
  if (idx === 5) {
    prepareScr(5);
    // Restore allergens
    if (S.allergens.length > 0 && S.allergens[0] !== 'brez') {
      document.getElementById('sel-al-toggle').value = 'ima';
      document.getElementById('q6-al-options').style.display = 'block';
      S.allergens.forEach(function(a) {
        document.querySelectorAll('#q6-al-options .pill').forEach(function(p) {
          if (p.dataset.val === a) p.classList.add('sel');
        });
      });
    }
    if (S.healthConditions.length > 0) {
      document.getElementById('sel-health-toggle').value = 'ima';
      document.getElementById('q6-health-options').style.display = 'block';
      S.healthConditions.forEach(function(hc) {
        document.querySelectorAll('#q6-health-options .pill').forEach(function(p) {
          if (p.dataset.val === hc) p.classList.add('sel');
        });
      });
    }
  }
}

// ===== SCREEN HANDLERS =====

// Q2: Age + Gender + Sterilised
function onQ2AgeChange() {
  var sel = document.getElementById('sel-age');
  sel.classList.remove('placeholder');
  var val = sel.value;
  var kittenWrap = document.getElementById('q2-kitten-age-wrap');
  var sterLine = document.getElementById('q2-ster-line');
  var sterHint = document.getElementById('q2-ster-hint');
  if (val === 'kitten') {
    kittenWrap.style.display = 'flex';
    // Skrij sterilizacijo za mucke — nima vpliva, itak dobijo Kitten formulo
    if (sterLine) sterLine.style.display = 'none';
    if (sterHint) sterHint.style.display = 'none';
    S.sterilised = false; // default za mucke
    // Don't set ageMonths yet — wait for kitten sub-age
    S.ageMonths = null;
    var kitSel = document.getElementById('sel-kitten-age');
    if (kitSel.value) {
      onQ2Change(); // kitten sub-age already selected
    }
  } else {
    kittenWrap.style.display = 'none';
    // Poka\u017ei sterilizacijo za adult/senior
    if (sterLine) sterLine.style.display = 'flex';
    S.sterilised = null; // reset — mora izbrati
    // Reset sterilised toggles
    document.querySelectorAll('#toggle-sterilised .toggle-btn').forEach(function(b) { b.classList.remove('sel'); });
    if (sterHint) sterHint.style.display = 'none';
    if (val === 'adult') S.ageMonths = 36;
    else if (val === 'senior') S.ageMonths = 120;
    else S.ageMonths = null;
    document.getElementById('q2-quote').textContent = S.gender ? getAgeQuote(S.name) : '';
  }
  checkQ2Ready();
}

function onQ2Change() {
  var kitSel = document.getElementById('sel-kitten-age');
  kitSel.classList.remove('placeholder');
  var val = kitSel.value;
  if (!val) { S.ageMonths = null; checkQ2Ready(); return; }
  // Map kitten sub-age to representative months
  var kittenMap = { '0-2': 2, '3-4': 4, '5-9': 7, '10-12': 11 };
  S.ageMonths = kittenMap[val] || null;
  document.getElementById('q2-quote').textContent = S.gender ? getAgeQuote(S.name) : '';
  checkQ2Ready();
}

function selectToggle(group, val) {
  var container = document.getElementById('toggle-' + group);
  if (!container) return;
  container.querySelectorAll('.toggle-btn').forEach(function(b) {
    b.classList.toggle('sel', b.dataset.val === val);
  });
  if (group === 'gender') {
    S.gender = val;
    // Update gender-aware texts
    var starEl = document.getElementById('q2-star');
    if (starEl) starEl.textContent = val === 'female' ? 'stara' : 'star';
    var sterEl = document.getElementById('q2-ster-label');
    if (sterEl) sterEl.textContent = val === 'female' ? 'Ali je sterilizirana?' : 'Ali je kastriran?';
    // Update hint if sterilised already selected
    var hint = document.getElementById('q2-ster-hint');
    if (hint && S.sterilised) {
      hint.textContent = val === 'male'
        ? 'Po kastraciji se lahko spremenijo prehranske potrebe.'
        : 'Po sterilizaciji se lahko spremenijo prehranske potrebe.';
    }
    // Update quote now that gender is known
    if (S.ageMonths) document.getElementById('q2-quote').textContent = getAgeQuote(S.name);
  } else if (group === 'sterilised') {
    S.sterilised = (val === 'yes');
    var hint = document.getElementById('q2-ster-hint');
    if (hint) {
      hint.style.display = S.sterilised ? '' : 'none';
      if (S.sterilised) {
        hint.textContent = S.gender === 'male'
          ? 'Po kastraciji se lahko spremenijo prehranske potrebe.'
          : 'Po sterilizaciji se lahko spremenijo prehranske potrebe.';
      }
    }
  }
  checkQ2Ready();
}

function checkQ2Ready() {
  var ageSel = document.getElementById('sel-age').value;
  var ageOk = false;
  if (ageSel === 'kitten') {
    ageOk = !!document.getElementById('sel-kitten-age').value;
  } else {
    ageOk = !!ageSel;
  }
  // Za mucke sterilizacija ni potrebna (S.sterilised = false by default)
  var sterOk = (ageSel === 'kitten') ? true : (S.sterilised !== null);
  var ok = ageOk && S.gender !== null && sterOk;
  document.getElementById('btn-q2').disabled = !ok;
}

function getAgeQuote(name) {
  if (!S.ageMonths) return '';
  var gPoss = S.gender === 'female' ? 'njen' : 'njegov';
  var gMucek = S.gender === 'female' ? 'mucka' : 'mu\u010dek';
  if (S.ageMonths < 12) {
    return name + ', ' + gMucek + ' \u2014 prilagodimo ' + gPoss + ' plan za rast. \ud83c\udfaf';
  }
  if (S.ageMonths >= 120) {
    var gStar = S.gender === 'female' ? 'starej\u0161a ma\u010dka' : 'starej\u0161i ma\u010dek';
    return name + ', ' + gStar + ' \u2014 prilagodimo ' + gPoss + ' plan. \ud83c\udfaf';
  }
  var gOdrasel = S.gender === 'female' ? 'odrasla ma\u010dka' : 'odrasel ma\u010dek';
  return name + ', ' + gOdrasel + ' \u2014 prilagodimo ' + gPoss + ' plan. \ud83c\udfaf';
}

// Q3: Weight + Body Condition
function onWeightInput() {
  var inp = document.getElementById('inp-weight');
  // Med tipkanjem: samo filtriramo neveljavne znake, NE zaokrozujemo
  var raw = inp.value.replace(',', '.').replace(/[^0-9.]/g, '');
  // Max 1 pika
  var parts = raw.split('.');
  if (parts.length > 2) raw = parts[0] + '.' + parts[1];
  var val = parseFloat(raw);
  // NE prepisuj inp.value med tipkanjem (uporabnik bi obtičal; clamp naredi blur)
  S.weightKg = (!isNaN(val) && val >= 0.5 && val <= 10) ? val : null;
  // Show/hide BC section
  var bcWrap = document.getElementById('bc-wrap');
  if (bcWrap) bcWrap.style.display = S.weightKg ? '' : 'none';
  checkQ3Ready();
}

function stepWeight(delta) {
  var cur = S.weightKg || 0;
  var next = Math.round((cur + delta) * 10) / 10;
  if (next < 0.5) next = 0.5;
  if (next > 10) next = 10;
  document.getElementById('inp-weight').value = String(next).replace('.', ',');
  onWeightInput();
}

function selectBC(bc) {
  document.querySelectorAll('#scr-q3 .oc').forEach(function(c) { c.classList.remove('sel'); });
  var el = document.querySelector('#scr-q3 .oc[data-bc="' + bc + '"]');
  if (el) el.classList.add('sel');
  S.bodyCondition = bc;
  // Show bc-wrap if hidden
  var bcWrap = document.getElementById('bc-wrap');
  if (bcWrap) bcWrap.style.display = '';
  // BC note
  var noteEl = document.getElementById('bc-note');
  if (noteEl) {
    var notes = {1:'Pove\u010damo dnevni odmerek za zdravo pridobivanje te\u017ee.', 3:'Odli\u010dno! Ohranimo idealno te\u017eo.', 4:'Rahlo zmanj\u0161amo odmerek za postopno normalizacijo.', 5:'Prilagojeni odmerki za postopno izgubo te\u017ee.'};
    noteEl.textContent = notes[bc] || '';
  }
  checkQ3Ready();
}

function checkQ3Ready() {
  document.getElementById('btn-q3').disabled = !(S.weightKg && S.bodyCondition);
}

// Q4: Eating Habits
function selectEating(val) {
  document.querySelectorAll('#scr-q4 .oc').forEach(function(c) { c.classList.remove('sel'); });
  var el = document.querySelector('#scr-q4 .oc[data-val="' + val + '"]');
  if (el) el.classList.add('sel');
  S.eatingHabits = val;
  // Desc + quote
  var descEl = document.getElementById('q4-desc');
  var quoteEl = document.getElementById('q4-quote');
  if (descEl) {
    var descs = {good:'Poje vse brez te\u017eav', sometimes:'V\u010dasih zavrne ali dolgo vohlja', veryPicky:'Zavra\u010da ve\u010dino hran'};
    descEl.textContent = descs[val] || '';
  }
  if (quoteEl) {
    var quotes = {good:'Super! Prava radost za vsakega lastnika! \ud83c\udf89', sometimes:'Ni\u010d hudega \u2014 hrustljava tekstura pogosto prepri\u010da tudi izbir\u010dne!', veryPicky:'Misli, da je ma\u010dji Gordon Ramsay? \ud83d\ude04 Brez skrbi \u2014 naravni vonj, hrustljavost in okus sve\u017eega mesa jih prepri\u010da.'};
    quoteEl.textContent = quotes[val] || '';
  }
  document.getElementById('btn-q4').disabled = false;
}

// Q5: Lifestyle
function selectLifestyle(val) {
  document.querySelectorAll('#scr-q5 .oc').forEach(function(c) { c.classList.remove('sel'); });
  var el = document.querySelector('#scr-q5 .oc[data-val="' + val + '"]');
  if (el) el.classList.add('sel');
  S.lifestyle = val;
  // Desc + quote
  var descEl = document.getElementById('q5-desc');
  if (descEl) {
    var f5 = S.gender === 'female';
    var descs = {
      'indoor': (f5 ? 'Doma\u010da ma\u010dka' : 'Doma\u010d ma\u010dek') + ' \u2014 prilagodimo kalorije za manj\u0161o porabo.',
      'indoor-active': (f5 ? 'Aktivna doma' : 'Aktiven doma') + ' \u2014 idealno ravnovesje med igro in po\u010ditkom.',
      'outdoor': 'Hodi ven \u2014 ve\u010d gibanja pomeni ve\u010djo potrebo po energiji.'
    };
    descEl.textContent = descs[val] || '';
  }
  document.getElementById('btn-q5').disabled = false;
}

// Q6: Allergens + Health
function onQ6AlToggle() {
  var val = document.getElementById('sel-al-toggle').value;
  document.getElementById('q6-al-options').style.display = (val === 'ima') ? 'block' : 'none';
  if (val === 'nima') {
    S.allergens = ['brez'];
    document.querySelectorAll('#q6-al-options .pill').forEach(function(p) { p.classList.remove('sel'); });
  } else {
    S.allergens = [];
  }
}

function togAllergen(el) {
  el.classList.toggle('sel');
  S.allergens = [];
  document.querySelectorAll('#q6-al-options .pill.sel').forEach(function(p) {
    S.allergens.push(p.dataset.val);
  });
  if (S.allergens.length === 0) S.allergens = ['brez'];
  // Info tekst
  var info = document.getElementById('q6-al-info');
  if (info) info.style.display = S.allergens.length > 0 && S.allergens[0] !== 'brez' ? '' : 'none';
}

function onQ6HealthToggle() {
  var val = document.getElementById('sel-health-toggle').value;
  document.getElementById('q6-health-options').style.display = (val === 'ima') ? 'block' : 'none';
  if (val === 'nima') {
    S.healthConditions = [];
    document.querySelectorAll('#q6-health-options .pill').forEach(function(p) { p.classList.remove('sel'); });
  }
}

function togHealth(el) {
  el.classList.toggle('sel');
  S.healthConditions = [];
  document.querySelectorAll('#q6-health-options .pill.sel').forEach(function(p) {
    S.healthConditions.push(p.dataset.val);
  });
  // Encouragement tekst
  var info = document.getElementById('q6-health-info');
  if (info) {
    if (S.healthConditions.length > 0) {
      var n = S.name || 'tvojo ma\u010dko';
      info.textContent = 'Ni skrbi \u2014 PLATINUM MeatCrisp ponuja re\u0161itve posebej za ma\u010dke kot je ' + n + '. Poglejmo! \ud83d\udd0d';
      info.style.display = '';
    } else {
      info.style.display = 'none';
    }
  }
}

// ===== EMAIL CAPTURE =====
function isValidEmail(e) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e);
}

function checkEmailReady() {
  var emailEl = document.getElementById('em-capture-input');
  var errEl = document.getElementById('em-error');
  var btn = document.getElementById('btn-email-submit');
  var optin = document.getElementById('em-optin').checked;
  var email = emailEl.value.trim();
  errEl.style.display = 'none';
  emailEl.style.borderColor = '';
  if (email && !isValidEmail(email)) {
    errEl.textContent = 'Vnesi veljaven email naslov (npr. ime@email.com)';
    errEl.style.display = 'block';
    emailEl.style.borderColor = 'var(--color-error)';
  }
  btn.disabled = !(email && isValidEmail(email) && optin);
}

function submitEmailAndContinue() {
  var emailEl = document.getElementById('em-capture-input');
  var email = emailEl.value.trim();
  if (!email || !isValidEmail(email) || !document.getElementById('em-optin').checked) {
    checkEmailReady();
    if (!email) emailEl.focus();
    return;
  }
  S.email = email;
  S.emailOptin = true;
  ga4('quiz_cat_email_submit', { quiz_name: 'cat-food-finder' });
  triggerLoading();
}

function skipEmail() {
  S.email = null;
  triggerLoading();
}

// ===== LOADING =====
function triggerLoading() {
  showScr(7); // loading screen
  var imgEl = document.getElementById('img-loading');
  if (imgEl) imgEl.src = CAT_IMAGES.loading;
  var subEl = document.getElementById('l-sub');
  if (subEl) subEl.textContent = 'Analiziram MeatCrisp formule za ' + S.name;

  var loadingTexts = [
    'Analiziram ' + S.name + ' profil...',
    'Pripravljam personaliziran plan...',
    'Ra\u010dunam dnevne porcije...',
    'Izbiram najbolj\u0161i MeatCrisp okus...',
    'Skoraj pripravljeno...'
  ];

  var textIdx = 0;
  var textEl = document.getElementById('l-text');
  textEl.textContent = loadingTexts[0];
  textEl.style.opacity = '1';
  var textInterval = setInterval(function() {
    textIdx++;
    if (textIdx < loadingTexts.length) {
      textEl.style.opacity = '0';
      setTimeout(function() {
        textEl.textContent = loadingTexts[textIdx];
        textEl.style.opacity = '1';
      }, 200);
    }
  }, 700);

  var res = calcResults();

  setTimeout(function() {
    clearInterval(textInterval);
    renderResults(res);
    showScr(8); // results screen
    ga4('quiz_cat_complete', {
      quiz_name: 'cat-food-finder',
      recommended_product: res.primary ? res.primary.id : null
    });
    submitQuizData(res);
  }, 3500);
}

// ===== LIFE STAGE DETECTION =====
function detectLifeStage() {
  if (S.ageMonths < 12) return 'kitten';
  if (S.sterilised) return 'sterilised';
  return 'adult';
}

// ===== FEEDING HELPERS =====
function getKittenBucket(ageMonths) {
  if (ageMonths <= 2) return '<=2';
  if (ageMonths <= 4) return '3-4';
  if (ageMonths <= 9) return '5-9';
  return '10-12';
}

function interp(table, w) {
  if (!table || table.length === 0) return 50;
  if (w <= table[0].w) return table[0].g;
  if (w >= table[table.length - 1].w) return table[table.length - 1].g;
  for (var i = 0; i < table.length - 1; i++) {
    if (w >= table[i].w && w <= table[i + 1].w) {
      var r = (w - table[i].w) / (table[i + 1].w - table[i].w);
      return Math.round(table[i].g + r * (table[i + 1].g - table[i].g));
    }
  }
  return table[0].g;
}

function interpField(table, w, field) {
  if (!table || table.length === 0) return 50;
  if (w <= table[0].w) return table[0][field];
  if (w >= table[table.length - 1].w) return table[table.length - 1][field];
  for (var i = 0; i < table.length - 1; i++) {
    if (w >= table[i].w && w <= table[i + 1].w) {
      var r = (w - table[i].w) / (table[i + 1].w - table[i].w);
      return Math.round(table[i][field] + r * (table[i + 1][field] - table[i][field]));
    }
  }
  return table[0][field];
}

function roundTo2_5(g) { return Math.round(g / 2.5) * 2.5; }
function roundTo5(g) { return Math.ceil(g / 5) * 5; } // legacy — used in RER clamp

// RER clamp: minimalni g/dan da pokrijemo bazalni metabolizem
// RER = 70 × teža^0.75 (kcal/dan)
// Minimalni grami = (RER / kcal_per_100g) × 100
function rerClamp(weightKg, kcalPer100g) {
  if (!weightKg || !kcalPer100g) return 0;
  var rer = 70 * Math.pow(weightKg, 0.75);
  var minG = (rer / kcalPer100g) * 100;
  return roundTo2_5(minG);
}

// ===== FEEDING CALCULATOR =====
function calcFeeding(p) {
  var recipe = p.flavor;
  var table = FEED[recipe];
  if (!table) table = FEED.chicken; // fallback

  // Activity multiplier (lifestyle-based for cats)
  var lifeMul = { 'indoor': 0.90, 'indoor-active': 1.00, 'outdoor': 1.15 };
  var actMul = lifeMul[S.lifestyle] || 1.0;

  // BC multiplier — bla\u017eji za sterilizirane (tabela \u017ee upo\u0161teva)
  // Izjema: BCS1 sterilised \u2192 adult faktor + adult tabela (potrebuje ve\u010d kalorij)
  var bcMapAdult = { 1: 1.15, 3: 1.00, 4: 0.90, 5: 0.85 };
  var bcMapSter  = { 1: 1.10, 3: 1.00, 4: 0.95, 5: 0.90 };
  var isUnderweightSter = (S.lifeStage === 'sterilised' && S.bodyCondition <= 1);
  var bcMul = (S.lifeStage === 'sterilised' && !isUnderweightSter)
    ? (bcMapSter[S.bodyCondition] || 1.0)
    : (bcMapAdult[S.bodyCondition] || 1.0);

  // BCS1 sterilised: uporabi adult tabelo (ve\u010d kalorij za pridobivanje te\u017ee)
  var feedStage = isUnderweightSter ? 'adult' : S.lifeStage;

  if (feedStage === 'kitten') {
    var bucket = getKittenBucket(S.ageMonths);
    var rows = table.kitten[bucket];
    if (!rows) rows = table.kitten['5-9'];
    var baseG = interp(rows, S.weightKg);
    // Kittens: apply BC but NOT activity multiplier (growth priority)
    var gpd = roundTo2_5(baseG * bcMul);
    return { dry: gpd };
  }

  if (feedStage === 'sterilised') {
    var sRows = table.sterilised;
    var gMin = interpField(sRows, S.weightKg, 'gMin');
    var gMax = interpField(sRows, S.weightKg, 'gMax');
    // Ena izra\u010dunana vrednost: povpre\u010dje min+max \u00d7 BC \u00d7 lifestyle
    var avgG = (gMin + gMax) / 2;
    var sterGpd = roundTo2_5(avgG * actMul * bcMul);
    // Hard floor: nikoli pod PLATINUM tabela minimum
    var floorG = roundTo2_5(gMin);
    if (sterGpd < floorG) sterGpd = floorG;
    return { dry: sterGpd };
  }

  // Adult
  var aRows = table.adult;
  var adultG = interp(aRows, S.weightKg);
  var adultGpd = roundTo2_5(adultG * actMul * bcMul);
  // RER clamp
  var rerMin = rerClamp(S.weightKg, p.kcal);
  if (adultGpd < rerMin) adultGpd = rerMin;
  return { dry: adultGpd };
}

// ===== COST CALCULATOR =====
function calcCost(p, feeding) {
  var gpd = feeding.dry || 50;
  return p.variants.map(function(v) {
    var cpd = Math.round((v.p / v.g) * gpd * 100) / 100;
    return {
      sku: v.sku, label: v.t, t: v.t, price: v.p, p: v.p, grams: v.g, g: v.g,
      cpd: cpd,
      cpw: Math.round(cpd * 7 * 100) / 100,
      cpm: Math.round(cpd * 30 * 100) / 100,
      days: gpd > 0 ? Math.floor(v.g / gpd) : 0,
      weeks: gpd > 0 ? Math.round(v.g / gpd / 7 * 10) / 10 : 0
    };
  });
}

function getDefaultVariantIdx(p) {
  var w = S.weightKg || 4;
  if (w <= 3) return 0;  // 400g
  if (w <= 5) return 1;  // 1.5kg
  return 2;              // 3kg
}

// Best CPD = najcenej\u0161e pakiranje \u00d7 max qty popust (za "Že od X €/dan")
// v2.2: Uporablja isto Shopify TRUNC-on-discount metodo kot renderQtyTable,
//       da je "Že od" usklajeno z dejansko ceno v qty tabeli (ne double-rounding).
function calcBestCpd(costs, gpd) {
  if (!costs || costs.length === 0) return null;
  var cheapest = costs.reduce(function(a, b) { return a.cpd < b.cpd ? a : b; });
  var maxRow = CAT_QTY[CAT_QTY.length - 1]; // qty=6, d=0.12
  // Shopify TRUNC metoda (enako kot renderQtyTable)
  var discPerUnit = maxRow.d > 0 ? Math.floor(cheapest.p * maxRow.d * 100) / 100 : 0;
  var total = Math.round((cheapest.p * maxRow.q - discPerUnit * maxRow.q) * 100) / 100;
  // Uporabi gpd (ne re-uporabljaj zaokro\u017eenega cheapest.cpd)
  if (!gpd || gpd <= 0) return null;
  return Math.round(total / (cheapest.g * maxRow.q) * gpd * 100) / 100;
}

// ===== SCORING ENGINE =====
function calcResults() {
  S.lifeStage = detectLifeStage();
  var alList = S.allergens.filter(function(a) { return a !== 'brez'; });

  // 1. Filter products by life stage
  // Izjema: premr\u0161ava sterilizirana (BCS1) dobi Adult (potrebuje ve\u010d kalorij)
  var effectiveStage = S.lifeStage;
  var isUnderweightSterilised = (S.lifeStage === 'sterilised' && S.bodyCondition <= 1);
  if (isUnderweightSterilised) effectiveStage = 'adult';
  var pool = PRODUCTS.filter(function(p) { return p.stage === effectiveStage; });

  // 2. Score each product
  pool.forEach(function(p) {
    p._score = (p.flavor === 'chicken') ? 80 : 75;
    // Picky modifiers
    if (S.eatingHabits === 'veryPicky' && p.flavor === 'chicken') p._score += 20;
    if (S.eatingHabits === 'sometimes' && p.flavor === 'chicken') p._score += 10;
    // Health modifiers
    if (S.healthConditions.indexOf('skin') !== -1 && p.flavor === 'fish') p._score += 30;
    if (S.healthConditions.indexOf('prebava') !== -1 && p.flavor === 'fish') p._score += 20;
    if (S.healthConditions.indexOf('weight') !== -1 && p.flavor === 'fish') p._score += 10;
  });

  // 3. Allergen filter
  var fallbackNotice = null;
  var preFilterPool = pool.slice();
  pool = pool.filter(function(p) {
    return !alList.some(function(a) { return p.allergens.indexOf(a) !== -1; });
  });
  if (pool.length === 0) {
    pool = preFilterPool;
    fallbackNotice = 'allergen-no-match';
  }

  // 4. Sort by score descending
  pool.sort(function(a, b) { return b._score - a._score; });

  // 5. Primary + Alt
  var primary = pool[0];
  var alt = pool.length > 1 ? pool[1] : null;
  var altIsWeightControl = false; // flag za UX opozorilo

  // BCS5 + nesterilizirana + ne-outdoor: alt = Sterilised istega okusa (kontrola te\u017ee)
  if (S.bodyCondition >= 5 && S.lifeStage === 'adult' && S.lifestyle !== 'outdoor') {
    var sterSameFlavor = PRODUCTS.filter(function(p) {
      return p.stage === 'sterilised' && p.flavor === primary.flavor;
    })[0];
    if (sterSameFlavor) {
      // Preveri alergen kompatibilnost
      var alConflict = alList.some(function(a) { return sterSameFlavor.allergens.indexOf(a) !== -1; });
      if (!alConflict) {
        alt = sterSameFlavor;
        altIsWeightControl = true;
      }
    }
  }

  // Privzeto: alt = nasprotni okus (\u010de ni weight control alt)
  if (!altIsWeightControl && alt && alt.flavor === primary.flavor) {
    var opp = null;
    for (var i = 0; i < pool.length; i++) {
      if (pool[i].flavor !== primary.flavor) { opp = pool[i]; break; }
    }
    if (opp) alt = opp;
  }

  // 6. Feeding + Cost
  var feeding = calcFeeding(primary);
  var cost = calcCost(primary, feeding);
  var altFeeding = alt ? calcFeeding(alt) : null;
  var altCost = alt ? calcCost(alt, altFeeding) : null;

  // 7. Upsells (max 2)
  var upsells = pickUpsells(alList);

  return {
    primary: primary,
    alt: alt,
    feeding: feeding,
    cost: cost,
    altFeeding: altFeeding,
    altCost: altCost,
    upsells: upsells,
    fallbackNotice: fallbackNotice,
    altIsWeightControl: altIsWeightControl
  };
}

function pickUpsells(alList) {
  alList = alList || S.allergens.filter(function(a) { return a !== 'brez'; });

  // Zberi signale
  var signals = [];
  if (S.healthConditions.indexOf('skin') !== -1) signals.push('skin');
  if (S.healthConditions.indexOf('prebava') !== -1) signals.push('prebava');
  if (S.healthConditions.indexOf('weight') !== -1) signals.push('weight');
  if (S.eatingHabits === 'veryPicky' || S.eatingHabits === 'sometimes') signals.push('picky');
  if (S.lifeStage === 'kitten') signals.push('kitten');
  var isSenior = S.ageMonths >= 96; // 8+ let
  if (isSenior) signals.push('senior');

  function matchesAllergens(u) {
    if (alList.length === 0) return true;
    if (!u.allergens || u.allergens.length === 0) return true;
    return !u.allergens.some(function(a) { return alList.indexOf(a) !== -1; });
  }

  var picks = [];
  var seen = {};
  function addPick(u) {
    if (!u || seen[u.id] || !matchesAllergens(u)) return;
    picks.push(u);
    seen[u.id] = true;
  }

  // Prioriteta 1: Senior \u2192 OralClean prvi (zobni kamen = tipi\u010dni senior problem)
  if (isSenior) {
    addPick(UPSELLS.find(function(u) { return u.id === 'oralclean'; }));
  }

  // Prioriteta 2: Ostali signal matches (po UPSELLS array order)
  UPSELLS.forEach(function(u) {
    if (picks.length >= 2) return;
    if (u.trigger.some(function(t) { return signals.indexOf(t) !== -1; })) {
      addPick(u);
    }
  });

  // Prioriteta 3: Default fallback (\u010de \u0161e vedno < 2)
  if (picks.length < 2) {
    UPSELLS.forEach(function(u) {
      if (picks.length >= 2) return;
      if (u.trigger.indexOf('default') !== -1) addPick(u);
    });
  }

  return picks.slice(0, 2);
}

// ===== HELPER: concern key =====
function getConcernKey() {
  if (S.eatingHabits === 'veryPicky') return 'picky';
  if (S.eatingHabits === 'sometimes') return 'picky';
  if (S.healthConditions.indexOf('skin') !== -1) return 'skin';
  if (S.healthConditions.indexOf('prebava') !== -1) return 'prebava';
  if (S.healthConditions.indexOf('weight') !== -1) return 'weight';
  if (S.lifeStage === 'kitten') return 'kitten';
  if (S.lifeStage === 'sterilised') return 'sterilised';
  return 'default';
}

// ===== GENERATE TEXT =====
function genWhyIntro(p) {
  var n = S.name || genderText('tvoj ma\u010dek', 'tvoja ma\u010dka');
  var gSter = genderText('kastriran', 'sterilizirana');
  var gPoss = genderText('njegov', 'njen');

  if (p.stage === 'kitten') {
    return n + ' raste \u2014 potrebuje specifi\u010den profil hranil. MeatCrisp Kitten ima prilagojeno razmerje beljakovin, kalcija in fosforja za zdrav razvoj. Dodanih 1.500 mg tavrina na kg \u2014 klju\u010dne aminokisline, ki jo ma\u010dka dobi samo iz hrane in podpira razvoj srca, vida in \u017eiv\u010dnega sistema mladi\u010da.';
  }
  if (p.stage === 'sterilised') {
    var gPostopek = genderText('Po kastraciji', 'Po sterilizaciji');
    return gPostopek + ' se lahko spremeni energijsko ravnovesje \u2014 apetit se pove\u010da, potreba po kalorijah pa zmanj\u0161a. MeatCrisp Sterilised je prilagojena formula za nadzorovan dnevni odmerek in la\u017ejo kontrolo te\u017ee. Receptura vsebuje 1.500 mg tavrina na kg \u2014 aminokisline, ki je ma\u010dka ne proizvede sama, a pomaga ohranjati mo\u010dno srce, dober vid in delovanje \u017eiv\u010dnega sistema.';
  }
  if (p.flavor === 'fish') {
    var fishPct = getMeatPct(p);
    return 'Sve\u017ea riba z omega-3 maš\u010dobnimi kislinami, ki lahko pomagajo pri zdravi ko\u017ei in sijo\u010di dlaki. ' + fishPct + '% sve\u017eega ribjega mesa \u2014 hrustljavo, kot mora biti. Dodanih 1.500 mg tavrina na kg \u2014 klju\u010dne aminokisline za srce, vid in \u017eiv\u010dni sistem, ki jo ma\u010dka mora dobiti iz hrane.';
  }
  // adult-chicken default
  return 'MeatCrisp pi\u0161\u010danec vsebuje ' + getMeatPct(p) + '% sve\u017eega mesa \u2014 brez mesne moke, brez umetnih arom ali oja\u010develcev okusa. FreshMeatDryer ohranja naravni vonj ki ga ' + n + ' obo\u017euje. Poleg tega receptura vsebuje 1.500 mg tavrina na kg \u2014 aminokisline, ki je ma\u010dka ne proizvede sama, a pomaga ohranjati zdravo srce, dober vid in delovanje \u017eiv\u010dnega sistema.';
}

// To\u010den dele\u017e mesa per produkt (iz Supabase composition_text)
function getMeatPct(p) {
  if (!p) return 82;
  if (p.id === 'kitten-fish') return 86;
  if (p.flavor === 'chicken') return 83;
  if (p.flavor === 'fish') return 82;
  return 82;
}

function genBenefits(p) {
  var benefits = [];
  benefits.push(getMeatPct(p) + '% sve\u017eega mesa \u2014 brez mesne moke');
  benefits.push('FreshMeatDryer \u2014 ohranja naravna mikrohranila, vitamine in minerale');

  // #3 by life stage
  if (p.stage === 'kitten') {
    benefits.push('Prilagojen za rast \u2014 optimalni kalcij in fosfor');
  } else if (p.stage === 'sterilised') {
    benefits.push('Prilagojena kalori\u010dna formula za kontrolo te\u017ee');
  } else {
    benefits.push('Polnovredna prehrana za odrasle ma\u010dke');
  }

  // #4 by condition
  var ck = getConcernKey();
  if (ck === 'picky') {
    benefits.push('Hrustljava tekstura in vonj mesa \u2014 prepri\u010data tudi izbir\u010dne ma\u010dke');
  } else if (ck === 'skin') {
    benefits.push('Omega-3 \u2014 lahko pripomore k mehki dlaki in zdravi ko\u017ei');
  } else if (p.flavor === 'fish') {
    benefits.push('Naravni ribji okus \u2014 neodporljiv za ma\u010dke');
  } else {
    benefits.push('Naravni vonj sve\u017eega pi\u0161\u010danca');
  }

  return benefits;
}

// ===== RESULTS TITLE =====
function getResultsTitle() {
  var n = S.name;
  if (S.healthConditions.indexOf('skin') !== -1) return 'Sijo\u010da dlaka za ' + n + ' \u2014 personaliziran plan';
  if (S.healthConditions.indexOf('prebava') !== -1) return 'La\u017eja prebava za ' + n + ' \u2014 personaliziran plan';
  if (S.healthConditions.indexOf('weight') !== -1) return 'Zdrava te\u017ea za ' + n + ' \u2014 personaliziran plan';
  if (S.eatingHabits === 'veryPicky' || S.eatingHabits === 'sometimes') return n + ' bo kon\u010dno ' + genderText('jedel', 'jedla') + ' z veseljem';
  if (S.lifeStage === 'kitten') return n + ' MeatCrisp plan za zdrav razvoj';
  if (S.lifeStage === 'sterilised') return 'Kontrola te\u017ee za ' + n + ' \u2014 personaliziran plan';
  return n + ' MeatCrisp plan za polno energijo';
}

// ===== PICK QUOTE =====
function pickQuote(productId) {
  var qs = QUOTES[productId];
  if (!qs || qs.length === 0) qs = QUOTES['adult-chicken'];
  return qs[Math.floor(Math.random() * qs.length)];
}

// ===== RENDER RESULTS =====
var RES_CACHE = null;

function renderFallbackNotice(notice, topProduct) {
  if (!notice) return '';
  var alList = S.allergens.filter(function(a) { return a !== 'brez'; });
  var alTxt = alList.join(', ');
  var prodName = topProduct ? topProduct.name : 'najbolj\u0161o razpolo\u017eljivo mo\u017enost';
  var txt = '\ud83d\udccc <b>Alergen: ' + alTxt + '</b> \u2014 recepture popolnoma brez tega alergena trenutno nimamo. Spodaj priporo\u010damo ' + prodName + ' za ' + S.name + '.<br><br>MeatCrisp hrana je pripravljena s FreshMeatDryer tehnologijo iz sve\u017eega mesa \u2014 zato so alergi\u010dne reakcije bistveno redkej\u0161e kot pri industrijsko predelani hrani. Priporo\u010damo, da poskusi\u0161 z manj\u0161o koli\u010dino. \u2713';
  return '<div style="background:#FFF8E7;border:1.5px solid #E8C547;border-radius:12px;padding:16px 20px;margin-bottom:20px;font-size:14px;line-height:1.6;color:#5A4B1C">' + txt + '</div>';
}

function renderResults(res) {
  RES_CACHE = res;
  var c = document.getElementById('res-content');
  var h = '';
  h += '<div class="res-fade" style="animation-delay:0ms">' + renderResHeader() + '</div>';
  h += renderFallbackNotice(res.fallbackNotice, res.primary);
  // Opozorilo za predebele sterilizirane indoor ma\u010dke
  if (S.lifeStage === 'sterilised' && S.bodyCondition >= 5 && S.lifestyle === 'indoor') {
    h += '<div style="background:#FFF3E0;border:1.5px solid #E8A847;border-radius:12px;padding:14px 18px;margin-bottom:16px;font-size:14px;line-height:1.6;color:#5A4B1C">';
    h += '\ud83d\udc69\u200d\u2695\ufe0f <b>Priporo\u010dilo:</b> ' + S.name + ' ima prekomerno telesno te\u017eo. Na\u0161 na\u010drt prehrane bo pomagal, ampak za u\u010dinkovito in varno huj\u0161anje priporo\u010damo posvet z veterinarjem.</div>';
  }
  // Opozorilo za premr\u0161avo sterilizirano ma\u010dko (dobi Adult namesto Sterilised)
  if (S.lifeStage === 'sterilised' && S.bodyCondition <= 1) {
    h += '<div style="background:#E8F5E9;border:1.5px solid #66BB6A;border-radius:12px;padding:14px 18px;margin-bottom:16px;font-size:14px;line-height:1.6;color:#2E7D32">';
    h += '\ud83c\udf3f <b>Zakaj Adult linija?</b> ' + S.name + ' je pod idealno te\u017eo in potrebuje ve\u010d kalorij za zdravo pridobivanje te\u017ee. Adult linija ima vi\u0161jo kalori\u010dno vrednost \u2014 ko dose\u017ee idealno te\u017eo, priporo\u010damo prehod na Sterilised linijo.</div>';
  }
  h += '<div class="res-fade" style="animation-delay:100ms">' + renderTransition() + '</div>';
  h += '<div class="res-fade" style="animation-delay:200ms">' + renderPrimaryCard(res) + '</div>';
  if (res.alt) {
    h += '<div class="res-fade" style="animation-delay:300ms">' + renderAltCard(res) + '</div>';
  }
  if (res.upsells && res.upsells.length > 0) {
    h += '<div class="res-fade" style="animation-delay:400ms">' + renderUpsells(res.upsells) + '</div>';
  }

  // Email capture
  h += '<div class="res-fade" style="animation-delay:550ms">' + renderEmailSection() + '</div>';

  // 6 zvezdic
  h += '<div class="res-fade" style="animation-delay:600ms">' + renderWhyPlatinum() + '</div>';

  // Hydration opomba
  h += '<div class="res-fade senior-note" style="animation-delay:750ms">';
  h += '\ud83d\udca7 Ob suhi hrani naj ima ' + (S.name || 'ma\u010dka') + ' vedno na voljo dovolj sve\u017ee vode.';
  h += '</div>';

  // Senior opomba (8+ let)
  if (S.ageMonths && S.ageMonths >= 96) {
    h += '<div class="res-fade senior-note" style="animation-delay:800ms">';
    h += '\ud83d\udc31 ' + (S.name || genderText('Va\u0161 ma\u010dek', 'Va\u0161a ma\u010dka')) + ' je ' + genderText('starej\u0161i ma\u010dek', 'starej\u0161a ma\u010dka') + '. Zrele ma\u010dke imajo ve\u010djo potrebo po aminokislini tavrin, ki pomaga ohranjati mo\u010dno srce in dober vid \u2014 MeatCrisp receptura jo zagotavlja v koli\u010dini 1.500 mg/kg. Priporo\u010dilo je informativno \u2014 \u010de opazite spremembe v te\u017ei, apetitu ali aktivnosti, priporo\u010damo posvet z veterinarjem.';
    h += '</div>';
  }

  // Disclaimer
  h += '<div class="res-fade" style="animation-delay:850ms">';
  h += '<p style="font-size:12px;color:#999;text-align:center;margin:24px 0 8px;line-height:1.5">';
  h += 'Priporo\u010dilo temelji na uradnih prehranskih smernicah proizvajalca in podatkih iz kviza. Namenjeno je kot informativna pomo\u010d pri izbiri hrane. Pri zdravstvenih te\u017eavah, izraziti prekomerni ali prenizki te\u017ei ali posebnih dietnih potrebah priporo\u010damo posvet z veterinarjem.';
  h += '</p></div>';

  c.innerHTML = h;
  initStickyCta(res);
}

function renderResHeader() {
  var n = S.name;
  var h = '<div class="res-header">';
  h += '<h1>\u2705 ' + getResultsTitle() + '</h1>';

  var f = S.gender === 'female';
  var lifeLabel = {kitten: f ? 'mladi\u010dka' : 'mladi\u010dek', adult: f ? 'odrasla ma\u010dka' : 'odrasel ma\u010dek', sterilised: genderText('kastriran', 'sterilizirana')}[S.lifeStage] || 'ma\u010dka';
  var lifeStyle = {'indoor': f ? 'doma\u010da' : 'doma\u010d', 'indoor-active': f ? 'aktivna doma' : 'aktiven doma', 'outdoor':'zunanja'}[S.lifestyle] || '';
  var tags = [S.weightKg + ' kg', lifeLabel, lifeStyle];
  if (S.eatingHabits === 'veryPicky') tags.push(f ? 'zelo izbir\u010dna' : 'zelo izbir\u010den');
  else if (S.eatingHabits === 'sometimes') tags.push(f ? 'v\u010dasih izbir\u010dna' : 'v\u010dasih izbir\u010den');
  if (S.healthConditions.indexOf('skin') !== -1) tags.push('ob\u010dutljiva ko\u017ea');
  if (S.healthConditions.indexOf('prebava') !== -1) tags.push('ob\u010dutljiva prebava');
  if (S.healthConditions.indexOf('weight') !== -1) tags.push('nagnjenost k debelosti');
  // Body condition label (BC3 = idealno, ne prika\u017eemo)
  var bcNum = parseInt((S.bodyCondition || '').toString()) || 3;
  var bcLabels = {
    1: f ? 'presuha' : 'presuh',
    4: f ? 'malce prete\u017eka' : 'malce prete\u017eek',
    5: f ? 'prete\u017eka' : 'prete\u017eek'
  };
  if (bcLabels[bcNum]) tags.push(bcLabels[bcNum]);
  var alDisp = S.allergens.filter(function(a) { return a !== 'brez'; });
  if (alDisp.length > 0) tags.push('alergija: ' + alDisp.join(', '));

  h += '<div class="res-summary">' + tags.join(' \u00b7 ') + '</div>';
  h += '<a href="#" class="res-edit-link" onclick="restoreScr(1);showScr(1);return false">\u270f\ufe0f Spremeni odgovore</a>';
  h += '</div>';
  return h;
}

function renderPrimaryCard(res) {
  var p = res.primary;
  var feeding = res.feeding;
  var costs = res.cost;
  var n = S.name;
  var defIdx = getDefaultVariantIdx(p);
  var def = costs[defIdx] || costs[0];

  var gpd = feeding.dry || 0;
  var gpdText = gpd + ' g';

  var h = '<div class="p-card">';
  h += '<div class="p-card-inner">';

  // LEFT: visual
  h += '<div class="p-card-visual">';
  h += '<span class="p-badge">Na\u0161e priporo\u010dilo za ' + n + '</span>';
  if (p.img) h += '<img src="' + p.img + '?width=400" alt="PLATINUM ' + p.name + '" class="p-card-img" loading="lazy">';
  h += '</div>';

  // RIGHT: content
  h += '<div class="p-card-content">';
  h += '<div class="p-name">PLATINUM ' + p.name + '</div>';

  // Price anchoring — best CPD (najcenej\u0161e pakiranje \u00d7 max qty popust)
  var bestCpd = calcBestCpd(costs, gpd);
  if (bestCpd) {
    h += '<div style="font-size:15px;color:var(--color-primary);font-weight:600;margin:-4px 0 14px">\u017de od ' + fmtEur(bestCpd) + ' \u20ac/dan</div>';
  }

  h += '<div class="p-why"><h4>Zakaj ta hrana za ' + n + '?</h4>';
  var whyIntro = genWhyIntro(p);
  if (whyIntro) h += '<p class="why-intro">' + whyIntro + '</p>';
  genBenefits(p).forEach(function(b) {
    h += '<div class="ben"><span class="ben-i">\u2713</span><span>' + b + '</span></div>';
  });
  h += '</div>';

  // Quote
  var q = pickQuote(p.id);
  h += '<div class="sp-quote"><div class="sp-text">\ud83d\udcac "' + q.text + '"</div><div class="sp-author">\u2014 ' + q.author + ' \u00b7 <span class="verified-badge">Preverjen kupec</span></div></div>';

  // Feeding info
  var gpd = feeding.dry || 0;
  if (gpd > 0) {
    h += '<div class="feed-info">';
    h += '<div class="f-stat"><span class="f-val">' + gpdText + '</span><span class="f-lbl">gramov / dan</span></div>';
    h += '<div class="f-stat"><span class="f-val">' + fmtEur(def.cpd) + ' \u20ac</span><span class="f-lbl">na dan</span></div>';
    h += '<div class="f-stat"><span class="f-val">' + fmtEur(def.cpm) + ' \u20ac</span><span class="f-lbl">na mesec</span></div>';
    h += '<div class="f-stat"><span class="f-val">~' + Math.max(1, Math.round(def.weeks)) + ' ted.</span><span class="f-lbl">paket ' + def.t + '</span></div>';
    h += '</div>';
  }

  // Variant selector
  h += '<div class="sizes" id="sz-' + p.id + '">';
  costs.forEach(function(v, vi) {
    h += '<div class="sz' + (vi === defIdx ? ' sel' : '') + '" onclick="selSz(\'' + p.id + '\',' + vi + ')">';
    h += '<span class="sz-n">' + v.t + '</span><span class="sz-p">' + fmtEur(v.p) + ' \u20ac</span><span class="sz-d">~' + v.days + ' dni</span></div>';
  });
  h += '</div>';

  // Qty discount table
  var gpd = feeding.dry || 50;
  h += renderQtyTable(def.price, def.grams, CAT_QTY, def.label, 'qty-' + p.id, gpd);

  // Trust bar
  h += '<div class="trust-bar">';
  h += '<span>\u2705 Vsaj 82% sve\u017eega mesa \u2014 brez mesne moke</span>';
  h += '<span>\ud83d\udee1\ufe0f 30-dnevna garancija</span>';
  h += '<span>\ud83d\ude9a Brezpla\u010dna dostava nad 29 \u20ac</span>';
  h += '</div>';

  // CTA
  h += '<button class="atc-btn" id="main-atc-btn" onclick="atc(\'' + p.handle + '\')">';
  h += 'Naro\u010di zdaj \u2013 brez tveganja</button>';

  h += '</div>'; // close .p-card-content
  h += '</div>'; // close .p-card-inner
  h += '</div>'; // close .p-card
  return h;
}

function renderAltCard(res) {
  var p = res.alt;
  var feeding = res.altFeeding;
  var costs = res.altCost;
  var n = S.name;
  if (!p || !costs) return '';

  var defIdx = getDefaultVariantIdx(p);
  var def = costs[defIdx] || costs[0];
  var gpd = feeding.dry || 0;
  var gpdText = gpd + ' g';

  var h = '<div class="p-card p-card-alt">';
  h += '<div class="p-card-inner">';

  h += '<div class="p-card-visual">';
  if (res.altIsWeightControl) {
    h += '<span class="p-badge p-badge-alt">\u2696\ufe0f Za intenzivnej\u0161o kontrolo te\u017ee</span>';
  } else {
    h += '<span class="p-badge p-badge-alt">Alternativa za ' + n + '</span>';
  }
  if (p.img) h += '<img src="' + p.img + '?width=400" alt="PLATINUM ' + p.name + '" class="p-card-img" loading="lazy">';
  h += '</div>';

  h += '<div class="p-card-content">';
  h += '<div class="p-name">PLATINUM ' + p.name + '</div>';

  // Price anchoring — best CPD za alt
  var altBestCpd = calcBestCpd(costs, gpd);
  if (altBestCpd) {
    h += '<div style="font-size:15px;color:var(--color-primary);font-weight:600;margin:-4px 0 14px">\u017de od ' + fmtEur(altBestCpd) + ' \u20ac/dan</div>';
  }

  // Weight control opozorilo
  if (res.altIsWeightControl) {
    h += '<div style="background:#FFF3E0;border:1.5px solid #E8A847;border-radius:10px;padding:12px 16px;margin-bottom:14px;font-size:13px;line-height:1.5;color:#5A4B1C">';
    h += 'Sterilised linija vsebuje manj kalorij in pomaga pri uravnavanju te\u017ee \u2014 primerna tudi za nesterilizirane ma\u010dke s prekomerno te\u017eo. <b>Za intenzivno kontrolo te\u017ee priporo\u010damo posvet z veterinarjem.</b>';
    h += '</div>';
  }

  h += '<div class="p-why"><h4>Zakaj ta hrana za ' + n + '?</h4>';
  var benefits = res.altIsWeightControl
    ? ['Manj kalorij na obrok \u2014 u\u010dinkovitej\u0161e huj\u0161anje', '7\u20138% manj kalorij v obroku \u2014 la\u017eje vzdr\u017eevanje te\u017ee', 'Visok dele\u017e mesa (82%) ohranja mi\u0161i\u010dno maso']
    : genBenefits(p);
  benefits.forEach(function(b) {
    h += '<div class="ben"><span class="ben-i">\u2713</span><span>' + b + '</span></div>';
  });
  h += '</div>';

  if (gpd > 0) {
    h += '<div class="feed-info">';
    h += '<div class="f-stat"><span class="f-val">' + gpdText + '</span><span class="f-lbl">gramov / dan</span></div>';
    h += '<div class="f-stat"><span class="f-val">' + fmtEur(def.cpd) + ' \u20ac</span><span class="f-lbl">na dan</span></div>';
    h += '<div class="f-stat"><span class="f-val">' + fmtEur(def.cpm) + ' \u20ac</span><span class="f-lbl">na mesec</span></div>';
    h += '</div>';
  }

  h += '<div class="sizes" id="sz-' + p.id + '">';
  costs.forEach(function(v, vi) {
    h += '<div class="sz' + (vi === defIdx ? ' sel' : '') + '" onclick="selSz(\'' + p.id + '\',' + vi + ')">';
    h += '<span class="sz-n">' + v.t + '</span><span class="sz-p">' + fmtEur(v.p) + ' \u20ac</span><span class="sz-d">~' + v.days + ' dni</span></div>';
  });
  h += '</div>';

  // Qty discount table
  var altGpd = feeding.dry || 50;
  h += renderQtyTable(def.price || def.p, def.grams || def.g, CAT_QTY, def.label || def.t, 'qty-' + p.id, altGpd);

  h += '<button class="atc-btn atc-btn-alt" onclick="atc(\'' + p.handle + '\')">';
  h += 'Naro\u010di zdaj \u2013 brez tveganja</button>';

  h += '</div>'; // close .p-card-content
  h += '</div>'; // close .p-card-inner
  h += '</div>'; // close .p-card
  return h;
}

// ===== "ZAKAJ MEATCRISP?" EDUCATION BLOCK =====
function renderWhyMeatCrisp() {
  var h = '<div class="mc-edu">';
  h += '<h3>\ud83d\udd25 Zakaj MeatCrisp?</h3>';
  h += '<p style="margin-bottom:16px"><b>FreshMeatDryer</b> \u2014 edinstvena tehnologija su\u0161enja iz sve\u017eega mesa.<br>Ve\u010dina hrane za ma\u010dke je ekstrudirana pri 150\u2013200\u00b0C. Mi su\u0161imo pri nizkih temperaturah s stalnim kro\u017eenjem zraka \u2014 ohranjeni vitamini, naravni okus.</p>';
  h += '<div class="why-grid" style="text-align:left">';
  h += '<div class="why-card"><span class="why-icon">\ud83e\udd69</span><strong>Sve\u017ee meso</strong><span>Vsaj 82% \u2014 ne mesna moka</span></div>';
  h += '<div class="why-card"><span class="why-icon">\ud83c\udf21\ufe0f</span><strong>Nizke temperature</strong><span>Ohranijo naravna mikrohranila, vitamine in minerale</span></div>';
  h += '<div class="why-card"><span class="why-icon">\ud83d\udc31</span><strong>Hrustljava tekstura</strong><span>Prepri\u010da tudi izbir\u010dne ma\u010dke</span></div>';
  h += '<div class="why-card"><span class="why-icon">\u2705</span><strong>Brez \u017eit in kemije</strong><span>Brez umetnih barvil in konzervansov</span></div>';
  h += '</div>';
  h += '</div>';
  return h;
}

// ===== TRANSITION PLAN + TIMELINE =====
function renderTransition() {
  var n = S.name;
  var ck = getConcernKey();
  var h = '';

  // --- 1. Konkreten 7-dnevni prehodni plan (vedno gradual za ma\u010dke) ---
  h += '<div class="timeline">';
  h += '<h3>\ud83d\udccb Na\u010drt prehoda na MeatCrisp za ' + acc(S.name) + '</h3>';
  h += '<p style="font-size:14px;color:var(--g700);margin:-4px 0 16px">Ma\u010dke so ob\u010dutljive na spremembe hrane \u2014 priporo\u010damo postopen prehod v 7 dneh.</p>';

  h += '<div class="tl-phase"><div class="tl-phase-title">Dan 1\u20132</div>';
  h += '<div class="tl-item"><span>\ud83d\udfe2</span><span><b>75% stara hrana</b> + <b>25% MeatCrisp</b></span></div>';
  h += '<div class="tl-item"><span>\ud83d\udca1</span><span>Zme\u0161aj v isti skledi, da se ' + n + ' navadi na nov vonj</span></div>';
  h += '</div>';

  h += '<div class="tl-phase"><div class="tl-phase-title">Dan 3\u20134</div>';
  h += '<div class="tl-item"><span>\ud83d\udfe1</span><span><b>50% stara hrana</b> + <b>50% MeatCrisp</b></span></div>';
  h += '</div>';

  h += '<div class="tl-phase"><div class="tl-phase-title">Dan 5\u20137</div>';
  h += '<div class="tl-item"><span>\ud83d\udfe0</span><span><b>25% stara hrana</b> + <b>75% MeatCrisp</b> \u2192 nato 100%</span></div>';
  h += '</div>';

  // Tip za izbirčne mačke
  if (S.eatingHabits === 'veryPicky' || S.eatingHabits === 'sometimes') {
    h += '<div style="background:var(--color-primary-light);border-radius:10px;padding:12px 16px;margin-top:12px;font-size:13px;line-height:1.5">';
    h += '<b>\ud83d\udca1 Tip za izbir\u010dne ma\u010dke:</b> Najprej ponudi nekaj briketov MeatCrisp lo\u010deno kot posladek, da se ' + n + ' navadi na vonj in okus. \u0160ele nato jih za\u010dni me\u0161ati v glavni obrok.';
    h += '</div>';
  }

  h += '</div>'; // close transition plan

  // --- 2. Kaj pri\u010dakovati po prehodu (motivacija) ---
  h += '<div class="timeline"><h3>Kaj pri\u010dakovati po prehodu na MeatCrisp</h3>';

  // Phase 1: First days
  h += '<div class="tl-phase"><div class="tl-phase-title">Prvi dnevi</div>';
  var p1 = {
    picky: ['Hrustljavi briketi takoj pritegnejo pozornost \u2014 naravni vonj mesa', n + ' za\u010dne jesti z veseljem'],
    skin: ['Brez problemati\u010dnih sestavin od prvega obroka', 'En sam vir beljakovin \u2014 manj mo\u017enosti za alergijo'],
    prebava: ['Prebavni trakt sprejme FreshMeatDryer brikete brez \u0161oka', 'Hrustljavi briketi \u2014 la\u017eje prebavljivo'],
    kitten: ['Majhni briketi prilagojeni za mlade zobke', n + ' za\u010dne jesti z veseljem'],
    sterilised: ['Prilagojena porcija za spremenjen metabolizem', n + ' je z veseljem \u2014 okus ostaja poln'],
    'default': ['Hrustljavi briketi di\u0161ijo po mesu, ne po krmi', n + ' za\u010dne jesti z veseljem']
  };
  (p1[ck] || p1['default']).forEach(function(t) { h += '<div class="tl-item"><span>\u2705</span><span>' + t + '</span></div>'; });
  h += '</div>';

  // Phase 2: Week 1-2
  h += '<div class="tl-phase"><div class="tl-phase-title">Teden 1\u20132</div>';
  var p2 = {
    picky: ['Komaj \u010daka na obrok \u2014 ni ve\u010d izbir\u010dnosti', 'Ve\u010d energije, bolj\u0161e po\u010dutje'],
    skin: ['Srbenje se zmanj\u0161uje, manj praskanja', 'Ko\u017ea se za\u010dne umirjati'],
    prebava: ['Prebava se vidno umirja \u2014 manj napihnjenosti', 'Urejena prebava \u2014 \u010dvrsto blato in manj vonja v strani\u0161\u010du'],
    kitten: ['Zdrava rast \u2014 energija in igrivost', 'Ve\u010d energije, bolj\u0161e po\u010dutje'],
    sterilised: ['Te\u017ea se stabilizira', 'Energija ostaja \u2014 manj kalorij, ne manj hranilnih snovi'],
    weight: ['Te\u017ea se za\u010dne po\u010dasi zni\u017eevati', 'Energija ostaja stabilna'],
    'default': ['Urejena prebava \u2014 \u010dvrsto blato in manj vonja v strani\u0161\u010du', 'Ve\u010d energije, bolj\u0161e po\u010dutje']
  };
  (p2[ck] || p2['default']).forEach(function(t) { h += '<div class="tl-item"><span>\u2705</span><span>' + t + '</span></div>'; });
  h += '</div>';

  // Phase 3: Week 3-4
  h += '<div class="tl-phase"><div class="tl-phase-title">Teden 3\u20134</div>';
  var p3 = {
    picky: ['Sijo\u010da dlaka, zdrava ko\u017ea', 'Komaj \u010daka na vsak obrok \u2014 poje do zadnjega zrna'],
    skin: ['Manj praskanja, rde\u010dica se postopoma umirja', 'Sijo\u010da dlaka, zdrava ko\u017ea'],
    prebava: ['Stabilna prebava', 'Sijo\u010da dlaka, ve\u010d energije'],
    kitten: ['Zdrav razvoj \u2014 lepa dlaka, mo\u010dni zobki in kosti', 'Polna energija za igro in raziskovanje'],
    sterilised: ['Te\u017ea pod kontrolo brez diete', 'Sijo\u010da dlaka, ve\u010d \u017eivljenjske energije'],
    weight: ['Vidno vitkej\u0161a postava', 'Ve\u010d energije, la\u017eje gibanje, sijo\u010da dlaka'],
    'default': ['Sijo\u010da dlaka, zdrava ko\u017ea', 'Komaj \u010daka na vsak obrok \u2014 poje do zadnjega zrna']
  };
  (p3[ck] || p3['default']).forEach(function(t) { h += '<div class="tl-item"><span>\u2705</span><span>' + t + '</span></div>'; });
  h += '</div>';

  h += '</div>'; // close .timeline
  return h;
}

// ===== UPSELLS (max 2, kot pri psih) =====
function renderUpsells(ups) {
  if (!ups || ups.length === 0) return '';
  var show = ups.slice(0, 2);
  var h = '<div class="ups-section">';
  h += '<h3>Dopolni ' + poss(S.name) + ' plan</h3>';
  show.forEach(function(u) {
    var upsIco = u.img ? '<img src="' + u.img + '?width=80" alt="' + u.name + '" class="ups-img">' : '';
    h += '<div class="ups-card">' + upsIco + '<div class="ups-info"><div class="ups-n">PLATINUM ' + u.name + '</div><div class="ups-d">' + u.desc + '</div></div>';
    h += '<button class="ups-btn" onclick="atc(\'' + u.handle + '\')">+ ' + fmtEur(u.price) + ' \u20ac</button></div>';
  });
  h += '</div>';
  return h;
}

// ===== SOCIAL PROOF =====
function renderSocialProof(productId) {
  var qs = QUOTES[productId];
  if (!qs || qs.length === 0) qs = QUOTES['adult-chicken'];
  // Show 2 random quotes
  var shuffled = qs.slice().sort(function() { return 0.5 - Math.random(); });
  var show = shuffled.slice(0, 2);

  var h = '<div class="sp-section">';
  h += '<h3>\ud83c\udfc6 #1 hrana za ma\u010dke v Nem\u010diji</h3>';
  show.forEach(function(q) {
    h += '<div class="sp-card">';
    h += '<div class="sp-text">\ud83d\udcac "' + q.text + '"</div>';
    h += '<div class="sp-author">\u2014 ' + q.author + ' \u00b7 <span class="verified-badge">Preverjen kupec</span></div>';
    h += '</div>';
  });
  h += '</div>';
  return h;
}

// ===== EMAIL SECTION on results =====
function renderEmailSection() {
  var n = S.name || 'tvoja ma\u010dka';
  var h = '';
  if (S.email) {
    h += '<div class="email-sec"><div style="font-size:24px;margin-bottom:8px">\u2705</div>';
    h += '<h3>Plan poslan!</h3>';
    h += '<p>Preveri ' + S.email + ' \u2014 plan prehrane za ' + n + ' je na poti.</p></div>';
  } else {
    h += '<div class="email-sec"><h3>Prejmi plan prehrane za ' + (S.name || 'tvojo ma\u010dko') + ' na email</h3>';
    h += '<p>Nasvete za prehod, priporo\u010dila in navodila \u2014 vse na enem mestu.</p>';
    h += '<div class="em-form">';
    h += '<input type="email" class="em-in" id="em-res-input" placeholder="tvoj@email.com" oninput="checkResEmail()" onblur="checkResEmail(true)">';
    h += '<button class="em-btn" id="btn-res-email" onclick="submitResEmail()">Po\u0161lji mi plan \u2192</button>';
    h += '</div>';
    h += '<div id="em-res-err" style="display:none;color:#FF6B6B;font-size:13px;margin:6px 0;text-align:center">Vnesi veljaven email (npr. ime@email.com)</div>';
    h += '<div class="em-perks"><span>\u2713 Plan prehrane</span><span>\u2713 Nasveti za prehod</span><span>\u2713 Brez spama</span></div>';
    h += '</div>';
  }
  return h;
}

function checkResEmail(showErr) {
  var inp = document.getElementById('em-res-input');
  var btn = document.getElementById('btn-res-email');
  var err = document.getElementById('em-res-err');
  var val = inp ? inp.value.trim() : '';
  var valid = isValidEmail(val);
  if (btn) btn.disabled = !valid;
  if (err) {
    // Poka\u017ei error samo ko uporabnik zapusti polje (blur) ali je \u017ee kaj vpisal
    if (showErr && !valid) {
      err.style.display = '';
      if (inp) inp.style.borderColor = '#C00000';
    } else {
      err.style.display = 'none';
      if (inp) inp.style.borderColor = '';
    }
  }
}

function submitResEmail() {
  var inp = document.getElementById('em-res-input');
  if (!inp || !isValidEmail(inp.value)) {
    checkResEmail(true);
    if (inp) inp.focus();
    return;
  }
  var email = inp.value.trim();
  S.email = email;
  S.emailOptin = true;
  ga4('quiz_cat_email_submit', {email: email});

  // Po\u0161lji SAMO direktno v Cat Email Flow webhook (NE re-submit Quiz Submit,
  // ker bi to sprozilo 2. Supabase INSERT in 2. QA Gmail alert).
  if (RES_CACHE) {
    var p = RES_CACHE.primary || {};
    var a = RES_CACHE.alt || null;
    var dBest = RES_CACHE.cost ? RES_CACHE.cost[getDefaultVariantIdx(p)] : null;
    var aBest = RES_CACHE.altCost && a ? RES_CACHE.altCost[getDefaultVariantIdx(a)] : null;
    var emailRow = {
      email: email,
      name: S.name,
      pet_name: S.name,
      gender: S.gender,
      life_stage: S.lifeStage,
      age_months: S.ageMonths,
      weight_kg: S.weightKg,
      body_condition: S.bodyCondition,
      eating_habits: S.eatingHabits,
      lifestyle: S.lifestyle,
      sterilised: S.sterilised,
      health_conditions: S.healthConditions,
      allergens: S.allergens.filter(function(al) { return al !== 'brez'; }),
      primary_handle: p.handle || '',
      alt_handle: a ? a.handle : '',
      dry_cost_cpd: dBest ? dBest.cpd : null,
      dry_cost_best_cpd: calcBestCpd(RES_CACHE.cost, RES_CACHE.feeding && RES_CACHE.feeding.dry),
      alt_cost_cpd: aBest ? aBest.cpd : null,
      feeding_gpd: RES_CACHE.feeding ? (RES_CACHE.feeding.dry || RES_CACHE.feeding.dryMax || null) : null,
      fallback_notice: RES_CACHE.fallbackNotice || null,
      transition_type: 'gradual',
      upsells: RES_CACHE.upsells.map(function(u) { return u.id; }),
      quiz_version: 'cat-v2.6',
      email_optin: true
    };
    fetch('https://igis-doo.app.n8n.cloud/webhook/cat-pff-email-flow', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ row: emailRow })
    }).then(function(r) {
      console.log('\ud83d\udce7 Cat Email flow triggered:', r.status);
    }).catch(function(err) {
      console.warn('\ud83d\udce7 Cat Email flow failed (non-blocking):', err.message);
    });
  }

  // Re-render email section to show confirmation
  var sec = inp.closest('.email-sec');
  if (sec) {
    sec.innerHTML = '<div style="font-size:24px;margin-bottom:8px">\u2705</div><h3>Plan poslan!</h3><p>Preveri ' + email + ' \u2014 plan prehrane za ' + (S.name||'tvojo ma\u010dko') + ' je na poti.</p>';
  }
}

// ===== 6 RAZLOGOV =====
function renderWhyPlatinum() {
  var h = '<div class="why-sec">';
  h += '<div class="why-sec-subtitle">Zakaj PLATINUM MeatCrisp?</div>';
  h += '<h3>6 razlogov, ki naredijo razliko</h3>';
  h += '<div class="why-grid">';
  h += '<div class="why-card"><span class="why-icon">\ud83d\udc31</span><strong>Za izbir\u010dne ma\u010dke</strong><span>Sprejme jo tudi najizbir\u010dnej\u0161a</span></div>';
  h += '<div class="why-card"><span class="why-icon">\ud83e\udd69</span><strong>Vsaj 82% sve\u017eega mesa</strong><span>V vsaki porciji</span></div>';
  h += '<div class="why-card"><span class="why-icon">\ud83d\udc08</span><strong>Hrustljava tekstura</strong><span>Ma\u010dke jo obo\u017eujejo</span></div>';
  h += '<div class="why-card"><span class="why-icon">\ud83c\udf21\ufe0f</span><strong>FreshMeatDryer</strong><span>Ve\u010d hranil iz sve\u017eega mesa</span></div>';
  h += '<div class="why-card"><span class="why-icon">\u2728</span><strong>Mehka in sijo\u010da dlaka</strong><span>Vidni rezultati</span></div>';
  h += '<div class="why-card"><span class="why-icon">\ud83c\udfc6</span><strong>#1 v Nem\u010diji</strong><span>3 leta zapored</span></div>';
  h += '</div>';
  h += '<p style="text-align:center;margin-top:16px;font-size:14px;color:var(--g400)">\u26a1 Brezpla\u010dna dostava nad 29 \u20ac</p>';
  h += '</div>';
  return h;
}

// ===== QTY DISCOUNT TABLE =====
function renderQtyTable(basePrice, packGrams, qtyTable, sizeLabel, tableId, gpd) {
  var h = '<div class="qty-tbl" id="' + tableId + '">';
  h += '<div class="qty-hdr" onclick="toggleQty(\'' + tableId + '\')">Ve\u010d kupi\u0161 \u2013 ve\u010d prihrani\u0161 \ud83d\udd3d</div>';
  h += '<div class="qty-body">';
  qtyTable.forEach(function(row, ri) {
    // Shopify per-line-item rounding: TRUNC popust na 1 kos (2dp), nato × qty, nato odšteje.
    // Primer 1.5 kg base 19.58 × 12% = 2.3496 → TRUNC 2.34 × 6 = 14.04 popust → 117.48 - 14.04 = 103.44.
    var discountPerUnit = row.d > 0 ? Math.floor(basePrice * row.d * 100) / 100 : 0;
    var total = Math.round((basePrice * row.q - discountPerUnit * row.q) * 100) / 100;
    var pricePerG = total / (packGrams * row.q);
    var cpd = gpd > 0 ? Math.round(pricePerG * gpd * 100) / 100 : 0;
    var cpm = Math.round(cpd * 30 * 100) / 100;
    var days = gpd > 0 ? Math.round(packGrams * row.q / gpd) : 0;
    var weeks = gpd > 0 ? Math.round(packGrams * row.q / gpd / 7 * 10) / 10 : 0;
    h += '<div class="qty-row' + (ri === 0 ? ' qty-sel' : '') + '" data-cpd="' + cpd + '" data-cpm="' + cpm + '" data-days="' + days + '" data-weeks="' + weeks + '" data-label="' + row.q + '\u00d7 ' + sizeLabel + '" onclick="selQty(\'' + tableId + '\',' + ri + ')">';
    h += '<span class="qty-rad"></span>';
    h += '<span class="qty-q">' + row.q + '\u00d7 ' + sizeLabel + '</span>';
    h += '<span class="qty-p">' + fmtEur(total) + ' \u20ac</span>';
    h += '<span class="qty-cpd">' + fmtEur(cpd) + ' \u20ac/dan</span>';
    h += '</div>';
  });
  h += '</div></div>';
  return h;
}

function toggleQty(tableId) {
  var tbl = document.getElementById(tableId);
  if (tbl) tbl.classList.toggle('qty-open');
}

function selQty(tableId, idx) {
  var tbl = document.getElementById(tableId);
  if (!tbl) return;
  var rows = tbl.querySelectorAll('.qty-row');
  rows.forEach(function(r, i) { r.classList.toggle('qty-sel', i === idx); });
  var sel = rows[idx];
  if (!sel) return;
  // Update feed-info with selected qty data
  var card = tbl.closest('.p-card');
  if (!card) return;
  var stats = card.querySelectorAll('.f-stat');
  if (stats.length >= 4) {
    stats[1].querySelector('.f-val').textContent = fmtEur(parseFloat(sel.dataset.cpd)) + ' \u20ac';
    stats[2].querySelector('.f-val').textContent = fmtEur(parseFloat(sel.dataset.cpm)) + ' \u20ac';
    stats[3].querySelector('.f-val').textContent = '~' + Math.max(1, Math.round(parseFloat(sel.dataset.weeks))) + ' ted.';
    stats[3].querySelector('.f-lbl').textContent = 'paket ' + sel.dataset.label;
  }
}

// ===== SIZE SELECTOR =====
function selSz(productId, idx) {
  var container = document.getElementById('sz-' + productId);
  if (!container) return;
  container.querySelectorAll('.sz').forEach(function(el, i) {
    el.classList.toggle('sel', i === idx);
  });
  var card = container.closest('.p-card');
  var costs = null;
  var gpd = 0;
  // Determine costs source
  if (RES_CACHE && RES_CACHE.primary && RES_CACHE.primary.id === productId) {
    costs = RES_CACHE.cost;
    gpd = RES_CACHE.feeding.dry || 50;
  } else if (RES_CACHE && RES_CACHE.alt && RES_CACHE.alt.id === productId) {
    costs = RES_CACHE.altCost;
    gpd = RES_CACHE.altFeeding ? (RES_CACHE.altFeeding.dry || 50) : 50;
  }
  if (costs && costs[idx]) {
    var v = costs[idx];
    // Update feed-info
    if (card) {
      var stats = card.querySelectorAll('.f-stat');
      if (stats.length >= 4) {
        stats[1].querySelector('.f-val').textContent = fmtEur(v.cpd) + ' \u20ac';
        stats[2].querySelector('.f-val').textContent = fmtEur(v.cpm) + ' \u20ac';
        stats[3].querySelector('.f-val').textContent = '~' + Math.max(1, Math.round(v.weeks)) + ' ted.';
        stats[3].querySelector('.f-lbl').textContent = 'paket ' + v.t;
      }
    }
    // Re-render qty table with new size
    var qtyEl = document.getElementById('qty-' + productId);
    if (qtyEl) {
      var tmp = document.createElement('div');
      tmp.innerHTML = renderQtyTable(v.p, v.g, CAT_QTY, v.t, 'qty-' + productId, gpd);
      qtyEl.parentNode.replaceChild(tmp.firstChild, qtyEl);
    }
  }
}

// ===== ADD TO CART / CTA =====
function atc(handle) {
  var url = 'https://platinum.si/products/' + handle + '?utm_source=cat-food-finder&utm_medium=quiz&utm_content=' + handle;
  ga4('quiz_cat_cta_click', { quiz_name: 'cat-food-finder', product_handle: handle });
  window.open(url, '_blank');
}

function notifyMe(handle) {
  var url = 'https://platinum.si/products/' + handle;
  window.open(url, '_blank');
}

// ===== STICKY MOBILE CTA =====
var _stickyObserver = null;

function initStickyCta(res) {
  if (_stickyObserver) { _stickyObserver.disconnect(); _stickyObserver = null; }
  var mainBtn = document.getElementById('main-atc-btn');
  var stickyEl = document.getElementById('sticky-cta');
  if (!mainBtn || !stickyEl) return;

  // Set sticky content
  var p = res.primary;
  stickyEl.innerHTML = '<button class="atc-btn sticky-atc-btn" onclick="atc(\'' + p.handle + '\')">Naro\u010di ' + p.short + ' \u2013 brez tveganja</button>';

  if ('IntersectionObserver' in window) {
    _stickyObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        stickyEl.classList.toggle('visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    _stickyObserver.observe(mainBtn);
  }
}

// ===== SUBMIT QUIZ DATA =====
function submitQuizData(res) {
  var payload = {
    species: 'cat',
    quiz_version: 'cat-v2.6',
    name: S.name,
    gender: S.gender,
    age_months: S.ageMonths,
    sterilised: S.sterilised,
    life_stage: S.lifeStage,
    weight_kg: S.weightKg,
    body_condition: S.bodyCondition,
    eating_habits: S.eatingHabits,
    lifestyle: S.lifestyle,
    allergens: S.allergens.filter(function(a) { return a !== 'brez'; }),
    health_conditions: S.healthConditions,
    email: S.email,
    email_optin: S.emailOptin,
    primary_product: res.primary ? res.primary.id : null,
    primary_handle: res.primary ? res.primary.handle : null,
    dry_cost_cpd: res.cost ? res.cost[getDefaultVariantIdx(res.primary)].cpd : null,
    dry_cost_best_cpd: calcBestCpd(res.cost, res.feeding && res.feeding.dry),
    alt_product: res.alt ? res.alt.id : null,
    alt_handle: res.alt ? res.alt.handle : null,
    alt_cost_cpd: res.altCost ? res.altCost[getDefaultVariantIdx(res.alt)].cpd : null,
    alt_cost_best_cpd: res.altCost ? calcBestCpd(res.altCost, res.altFeeding && res.altFeeding.dry) : null,
    feeding_gpd: res.feeding.dry || res.feeding.dryMax || null,
    fallback_notice: res.fallbackNotice || null,
    transition_type: 'gradual',
    upsells: res.upsells.map(function(u) { return u.id; }),
    dataSource: QUIZ_DATA.dataSource,
    utmSource: (function() { try { return new URLSearchParams(window.location.search).get('utm_source'); } catch(e) { return null; } })(),
    utmMedium: (function() { try { return new URLSearchParams(window.location.search).get('utm_medium'); } catch(e) { return null; } })(),
    utmCampaign: (function() { try { return new URLSearchParams(window.location.search).get('utm_campaign'); } catch(e) { return null; } })(),
    quizDurationSec: S._startTime ? Math.round((Date.now() - S._startTime) / 1000) : null,
    timestamp: new Date().toISOString()
  };

  // Submit to n8n webhook
  console.log('[CAT PFF] Submitting quiz data...');
  fetch('https://igis-doo.app.n8n.cloud/webhook/cat-food-finder-submit', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  }).then(function(r) {
    console.log('[CAT PFF] Submit ' + (r.ok ? 'OK' : 'err ' + r.status));
  }).catch(function(e) {
    console.warn('[CAT PFF] Submit failed:', e.message);
  });
}

// ===== NAME INPUT =====
function onNameInput() {
  var nameInp = document.getElementById('inp-name');
  var btn = document.getElementById('btn-q1');
  if (btn) btn.disabled = !(nameInp && nameInp.value.trim());
}

// ===== STICKY CTA =====
function stickyAtc() {
  if (RES_CACHE && RES_CACHE.primary) atc(RES_CACHE.primary.handle);
}

// ===== INIT =====
document.addEventListener('DOMContentLoaded', function() {
  showScr(0);
  // Welcome screen image
  var imgW = document.getElementById('img-welcome');
  if (imgW) imgW.src = CAT_IMAGES.welcome;
  // Name input enter key
  var nameInp = document.getElementById('inp-name');
  if (nameInp) {
    nameInp.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && nameInp.value.trim()) startQuiz();
    });
  }
  // Weight input: zaokrozi na 0.5 ob blur (ko zapusti polje)
  var wInp = document.getElementById('inp-weight');
  if (wInp) {
    // Select all on focus — da tipkanje ZAMENJA obstoječo vrednost (npr. "10" → "2,5")
    wInp.addEventListener('focus', function() { setTimeout(function() { wInp.select(); }, 0); });
    wInp.addEventListener('blur', function() {
      var raw = wInp.value.replace(',', '.').replace(/[^0-9.]/g, '');
      var val = parseFloat(raw);
      if (!isNaN(val) && val > 0) {
        val = Math.round(val * 2) / 2;
        if (val > 10) val = 10;
        if (val < 0.5) val = 0.5;
        wInp.value = String(val).replace('.', ',');
        S.weightKg = val;
      } else {
        wInp.value = '';
        S.weightKg = null;
      }
      var bcWrap = document.getElementById('bc-wrap');
      if (bcWrap) bcWrap.style.display = S.weightKg ? '' : 'none';
      checkQ3Ready();
    });
  }
});